export default {
    "cn": {
        "register": {
            "title": "注册新帐户",
            "firstName": "名",
            "lastName": "姓氏",
            "email": "邮件",
            "password": "密码",
            "confirmPassword": "确认密码",
            "companyName": "公司名",
            "companyRegistrationNumber": "公司注册号",
            "address": "地址",
            "city": "城市",
            "postalCode": "邮编",
            "country": "国家",
            "industry": "行业",
            "position": "职位",
            "phoneNumber": "电话号码",
            "manageAccount": {
                "help": "管理员将上传您的视频、字幕"
            },
            "register-button": "注册",
            "managedAccount": "我允许管理员管理我的帐户",
            "allow-admin-to-manage-account": "管理员将上传您的视频、字幕",
            "acceptTerms": "我接受条款和条件",
            "acceptNewsletter": "我同意接收微享平台新闻",
            "login": "登录",
            "success": "注册成功",
            "success-text": "请检查您的收件箱并确认您的邮箱地址。确认后，等待系统接受您的账户。之后您会收到一封确认邮件并可以登陆。谢谢。",
            "success-verified": "请等待系统批准您的账户。之后，您将收到一封确认邮件，就可以登陆了。谢谢。",
            "approved": "系统已批准"
        },
        "settings": {
            "slot-subscription-price": "位置认购价",
            "slot-subscription-vat": "位置认购税",
            "slot-subscription-discount": "位置认购折扣",
            "slot-subscription-price-day-threshold": "每日门槛的时段价格",
            "not-defined": "设置：未定义设置",
            "managed_user_account_subscription_product": "托管用户帐户订阅计划",
            "mail_new_account_registered": "电子邮件-已重新分配新帐户",
            "mail_new_manage_account_subscription": "电子邮件-新的托管帐户订阅",
            "mail_new_tags_order": "电子邮件-新的订单标记",
            "mail_new_transaction_success": "电子邮件-新的订单标记",
            "mail_failed_transaction": "电子邮件-转移失败",
            "max_sku_slots": "最多商品位置",
            "max_chars_title_subtitle": "最多图标题目/副标题",
            "max_chars_sku_description": "单位商品描述的字数上限",
            "mail_expiry_sku": "邮件-单位商品即将过期"
        },
        "order": {
            "orders": "订单",
            "order": "订单",
            "id": "用户号",
            "date": "日期",
            "status": "状态",
            "quantity": "数量",
            "total": "总计",
            "no-items": "无订单",
            "subscriptions": "订阅",
            "name": "名字",
            "created_on": "创建于",
            "due_date": "过期日",
            "price-per-month": "月费",
            "view": "浏览",
            "unsubscribe": "取消订阅",
            "invoices": "发票",
            "no-invoices": "无发票",
            "lines": "LINES",
            "download-pdf": "下载PDF",
            "paid-at": "支付时间",
            "price": "价格",
            "summary": "订单总计",
            "manual_pay": "支付将手动进行",
            "manual_pay_pending": "支付等待中",
            "manage_plan": "管理"
        },
        "passwords": {
            "password": "密码必须至少为八个字符，并且与确认匹配。",
            "reset": "您的密码已重置！",
            "sent": "我们已经通过电子邮件发送了您的密码重置链接！",
            "token": "此密码重置密钥无效。",
            "user": "我们找不到具有该电子邮件地址的用户。"
        },
        "profile": {
            "my-account": "我的账户",
            "account-details": "账户明细",
            "change-password": "修改密码",
            "old-password": "旧密码",
            "new-password": "新密码",
            "new-password-confirm": "确认密码",
            "account-deleted": "账户已删除",
            "password-changed": "密码已修改",
            "incorrect-old-password": "旧密码不正确",
            "profile-updated": "简介已更新",
            "email-taken": "电子邮件已被其他帐户注册过",
            "edit-profile": "编辑简介",
            "blocked-by": "帐户在{date}被{user}阻止",
            "account-status": "账户状态",
            "block-user": "阻止用户",
            "block-user-confirm": "解释消息",
            "reason": "原因",
            "unblock-user": "取消阻止用户",
            "account-role": "帐户角色",
            "save-role": "保存角色"
        },
        "subscription": {
            "new-subscription": "新的订阅",
            "select": "选择",
            "subscribe-plan": "订阅：月费",
            "subscribe": "订阅",
            "create-invoice": "建立账单"
        },
        "cart": {
            "go-to-cart": "购物车 ({items} pcs.)",
            "added": "更新购物车",
            "sku": "商品页面",
            "type": "类型",
            "quantity": "数量",
            "unit-price": "单价",
            "subtotal": "小计",
            "total": "总计",
            "pcs": "件数",
            "no-items": "无项目",
            "cart": "购物车",
            "year": "年",
            "years": "年",
            "checkout": "离开",
            "invoice-details": "发票明细",
            "vat-not-included": "不含税",
            "name": "名字",
            "shipping-details": "运输明细",
            "copy-from-invoice-details": "发票明细复本",
            "no-items-in-cart": "由于购物车中没有商品，无法进行结账",
            "pending": "待定",
            "complete": "完成",
            "shipped": "已发货",
            "invoice": "发票",
            "shipping": "运输",
            "place-order": "下订单",
            "order-placed": "下单成功",
            "product": "商品",
            "update": "更新",
            "updated": "购物车更新",
            "redirecting-to-payment": "重新指向支付",
            "payment-received": "支付已接受"
        },
        "subscription-product": {
            "create": "创建",
            "name": "名字",
            "price": "价格",
            "vat": "增值税",
            "no-content": "无项目",
            "edit": "编辑",
            "delete": "删除",
            "subscription-products": "订购计划",
            "cant-delete-managed-account-subscription": "无法删除托管帐户订阅。首先在设置中更改它。",
            "draft": "草稿",
            "published": "已发布",
            "pending_payment": "待付款项",
            "description": "描述",
            "months": "月"
        },
        "order-history": {
            "date": "日期",
            "author": "作者",
            "content": "内容",
            "post": "发布消息"
        },
        "common": {
            "voypp": "微享平台",
            "tagline": "产品平台上的视频",
            "home": "主页",
            "terms-and-conditions": "条款",
            "welcome": "欢迎",
            "filter": "筛选",
            "search": "搜索",
            "reset": "重新设置",
            "previous": "先前的",
            "next": "下一个",
            "pagination-summary": "显示：每页项，共：项",
            "menu": {
                "about": "关于微享平台",
                "how-it-works": "它如何运行",
                "prices": "价格",
                "join-the-platform": "加入平台",
                "contact": "联系方式",
                "login": "登录",
                "register": "注册",
                "dashboard": "数据板",
                "logout": "退出"
            },
            "administration": "管理",
            "users": "用户",
            "tags": "标记",
            "tag-prices": "标记价格",
            "content": "内容",
            "translations": "翻译",
            "close": "关闭",
            "save": "保存",
            "non-empty-html": "：属性不能为空",
            "are-you-sure": "你确定你想这么做吗？",
            "save-error-title": "保存数据时出错",
            "generic-error": "出了点问题。请检查下列内容。",
            "impersonating": "您正在模拟此用户。",
            "impersonating-stop": "返回",
            "copyright-protected": "版权保护",
            "powered-by": "以.为动力",
            "trashed": "垃圾",
            "with-trashed": "带着垃圾",
            "only-trashed": "只有垃圾",
            "yes": "是",
            "no": "不",
            "back": "后面",
            "pcs": "件数",
            "delete": "删除",
            "all": "全部",
            "data-saved": "数据保存",
            "no-items": "无项目",
            "parameter-must-be-a-list": "参数：属性必须是列表",
            "locale-not-set": "区域设置：属性的区域设置：未设置参数",
            "page": "页",
            "widget": "小窗",
            "platform": "平台",
            "video": "微享平台服务器上的视频",
            "vimeo": "外部服务器上的视频",
            "image": "图像",
            "privacy-policy": "隐私政策",
            "monthly-subscription": "每月订阅：产品",
            "payment-successful": "付款成功",
            "pending-payment": "待支付",
            "payment-error": "支付错误",
            "paid": "已支付",
            "overdue": "已过期",
            "canceled": "已取消",
            "draft": "草稿",
            "invoices": "发票",
            "cancel": "取消",
            "settings": "设置",
            "ok": "好",
            "dashboard": "数据版",
            "subscription-plans": "订阅计划",
            "subscription-plan": "订阅计划",
            "pay-now": "现在支付",
            "menu-footer": {
                "facebook": "脸书",
                "newsletter": "新闻稿",
                "e-mail": "邮件",
                "contact": "联系方式",
                "gdpr": "GDPR",
                "terms-and-conditions": "条款",
                "login": "登录"
            },
            "mail-recommendation-body": "向您推荐此页面: {appURL}",
            "mail-recommendation-subject": "推荐",
            "mail-recommendation-title": "通过邮件发送推荐",
            "fb-share-title": "分享到脸书",
            "follow": "关注",
            "top": "置顶",
            "share": "分享",
            "sku-mail-recommendation-body": "我发现了一些有意思的信息 {producer} {brand}: {appURL}",
            "sku-fb-recommendation-body": "我发现了一些有意思的信息 {producer} {brand}: {appURL}",
            "subscription-to": "订阅：商品",
            "order": "购买",
            "cookie": {
                "consent_text": "本微网站使用cookies来识别您的信息并解析使用者的习惯，以便进行系统优化。",
                "uses_cookies": "本网站使用信息记录程序",
                "only_required": "只允许要求的信息记录程序",
                "allow_all": "全部允许信息记录程序",
                "view_all": "浏览所有信息记录程序",
                "used": "本网站使用的信息记录程序",
                "name": "名字",
                "description": "描述",
                "no_cookie": "无信息记录程序",
                "loading": "下载中",
                "reject": "拒绝信息记录程序"
            },
            "example": "例如",
            "word": "词语",
            "submit": "提交"
        },
        "prices": {
            "prices": "价格",
            "configure-title": "配置价格",
            "explain": "首先添加所有可能的标签类型和所有最低价格品类。",
            "types": "类型",
            "min-quantity": "最低数量",
            "add-new-type": "添加新类型",
            "add-new-year": "添加新年份",
            "add-new-min-quantity": "添加新的最低数量",
            "type": "类型",
            "year": "年",
            "quantity": "数量",
            "delete": "删除",
            "no-types": "尚未定义任何类型。使用上面的表单添加一个。",
            "no-years": "尚未定义任何年份。使用上面的表单添加一个。",
            "no-min-quantity": "尚未定义任何最低数量。使用上面的表单添加一个。",
            "save-configuration": "保存配置",
            "configuration-saved": "配置已保存",
            "years": "年",
            "prices-input-not-a-list": "{attribute} 属性不是价目表",
            "price-does-not-have-a-type-set": "{attribute} 属性具有缺少类型变量的价格",
            "price-does-not-have-a-year-set": "{attribute} 属性具有缺少年份变量的价格",
            "price-does-not-have-a-quantity-set": "{attribute} 属性具有缺少数量变量的价格",
            "price-does-not-have-a-price-set": "{attribute} 属性具有缺少价格变量的价格",
            "tag-prices": "价格标记"
        },
        "invoice": {
            "invoice": "发票",
            "vat": "增值税",
            "date": "日期",
            "due_date": "到期日",
            "product": "商品",
            "quantity": "数量",
            "rate": "价格",
            "subtotal": "小计",
            "total": "总计",
            "from": "从",
            "to": "到",
            "name": "名字",
            "company": "公司",
            "address": "地址",
            "this-month-income": "本月收入",
            "income-change-thesame": "与上个月相比没有变化",
            "income-change-decrease": "：自上个月以来下降百分之",
            "income-change-increase": "：自上个月以来上升百分之",
            "description": "描述",
            "amount": "金额",
            "price_unit": "单价",
            "discount": "折扣",
            "total_net": "总净价",
            "base": "基础",
            "disclaimer_title": "备注和信息：",
            "disclaimer_line1": "本发票自开具之日起5个工作日内未付款，如合同无其他条款，本发票自动取消，包括订单。 此发票必须保留用于任何索赔和保修目的。",
            "disclaimer_line2": "去www.voypp.com微享平台网站了解更多",
            "disclaimer_line3": "感谢您选择微享平台",
            "paid_at": "付款方式：",
            "demo": "Demo"
        },
        "content": {
            "title": "题目",
            "created-date": "创建于",
            "no-content": "无内容",
            "create": "创建",
            "content": "内容",
            "edit": "编辑",
            "type": "类型",
            "slug": "代码",
            "slug-taken": "代码已使用",
            "preview": "预览",
            "delete": "删除",
            "content-deleted": "内容已删除"
        },
        "translations": {
            "id": "身份",
            "save_error_title": "保存翻译出错"
        },
        "auth": {
            "failed": "这些凭据与我们的记录不匹配。",
            "throttle": "登录尝试过多。请在{seconds}秒内重试。",
            "login-title": "登录",
            "login-button": "登录",
            "logout-button": "退出",
            "forgot-password-link": "忘记密码？",
            "remember": "记住我",
            "register-title": "注册",
            "register-button": "此处注册",
            "login-text": "已经拥有账户？",
            "register-text": "需要新账户？",
            "password": "密码",
            "email": "邮件",
            "profile": "简介",
            "verify-your-email-address": "验证您的电子邮件地址",
            "verify-check-email": "在继续之前，请检查您的电子邮件以获取验证链接。",
            "resend-verification-email": "再次发送验证邮件",
            "verification-ok": "可以邮件验证",
            "verification-resent": "新的验证链接已发送到您的电子邮件地址。",
            "resetPass": "重新设置密码",
            "confirmPassword": "确认密码"
        },
        "pages": {
            "home": {
                "prices": {
                    "content": "起价为0.15欧元，最高为每个NFC标签5.04欧元，视数量而定。 此外，您还可以订购特殊形状或图形、特殊用途的标签，如金属支架或NFC+RFID组合标签。 同时，您可以自行制作NFC标签或二维码标签，在这种情况下，您可以使用平台，只需支付活跃槽的费用，5欧元/槽/月。 我们可以管理您的帐户25欧元/月，无论SKU的数量。增值税不包括在内。",
                    "title": "价格"
                },
                "title": "NFC/QR 微享平台技术支持产品",
                "subtitle": "发挥您的创造力，通过您的产品直接与客户交谈，无论他们在哪里遇到它。",
                "about": {
                    "title": "关于微享平台",
                    "content": "VOYPP®是首个NFC/QR自动化直接面向消费者平台，可在货架上或客户可能与产品直接接触的任何其他位置提供相关信息。 <br />扫描NFC标签/二维码，即可即时访问产品面板，最多可显示10个相关短视频或图形。 查找活动促销或其他重要信息。"
                },
                "how-it-works": {
                    "title": "系统如何运作",
                    "content": "您是消费者，并且发现了带有Voypp NFC标签或二维码的产品/服务吗？ 启用手机NFC功能，用手机触摸产品上的标签或扫描二维码。 打开面板并选择要观看的视频。 1分钟左右的短片将为您讲解所选话题的要义。 查找您所在地区可用的促销活动。 你和产品。 经验丰富的内容创作者将推动您更好地评估产品/服务。"
                },
                "join": {
                    "title": "加入平台",
                    "content": "<p>您是厂家，想加入我们的平台吗？ 登录并在那里发布您的SKU。 确定所需的NFC标签/二维码标签数量，创建并上传内容。 这就是你需要做的全部事情。 剩下的我们来管理。 您的标签可以在世界任何地方(包括中国)访问。 用您的手机扫描下面的二维码，了解产品页面的外观和功能。</p>",
                    "button": "登录"
                },
                "tagline": "您的产品平台上的视频"
            },
            "contact": {
                "title": "联系方式",
                "full_name": "姓名全称",
                "email": "邮件",
                "message": "信息",
                "message_placeholder": "输入您的信息",
                "phone_placeholder": "输入您的电话号码",
                "city_placeholder": "城市",
                "phone": "电话号码",
                "city": "城市",
                "submit": "提交信息",
                "mandatory_fields": "必填项",
                "email_placeholder": "输入您的邮箱地址",
                "full_name_placeholder": "输入您的全名"
            }
        },
        "sku": {
            "sku-list": "商品列表",
            "edit": "编辑",
            "order-new-sku": "定制新的商品",
            "prices": "价格",
            "code": "代码",
            "description": "描述",
            "tags-ordered": "标记已定",
            "created-date": "创建日期",
            "no-skus": "商品未定义",
            "order": "订单",
            "sku": "商品",
            "order-labels": "定制标签",
            "analytics": "分析",
            "new-sku": "新的商品",
            "edit-sku-information": "编辑商品信息",
            "save": "保存",
            "code-explain": "3个字符+2个数字",
            "slot": "位置",
            "add-slot": "添加位置",
            "remove-slot": "移除位置",
            "video": "视频",
            "image": "图像",
            "producer": "厂家",
            "brand": "品牌",
            "video-file": "视频文件",
            "video-file-help": "最大加载视频为400MB",
            "image-file": "图像文件",
            "image-file-help": "(.jpg, .png, .gif 文件, 最大 2Mb)",
            "media-type": "媒体类型",
            "preview": "预览",
            "action": "行动",
            "url": "Url",
            "saving-title": "保存商品",
            "delete": "删除",
            "title": "标题",
            "title-help": "最多25个字符的标题+副标题",
            "subtitle": "副标题",
            "characters-remaining": "内容字符剩余：",
            "uploading": "正在上传，请在传输完成之前不要关闭此窗口。",
            "video-will-be-loaded-soon": "这里很快就会加载一段视频。请稍后再检查。",
            "live-url": "实时URL",
            "no-live-url-yet": "只要您订购了至少一个标签，URL就会显示出来。",
            "views-count": "浏览统计",
            "current-image": "目前图像",
            "delete-image": "删除图像",
            "draft": "草稿",
            "published": "发行",
            "tags": "标记",
            "tags-orderd-pcs": "标记已定件数",
            "order-date": "订单日期",
            "delivery_date": "发货日期",
            "status": "状态",
            "uid-loaded": "UID上传",
            "unit-price": "单价",
            "total": "总计",
            "active-blocked": "激活/阻止",
            "pending": "待定",
            "in_production": "在生产中",
            "delivered": "已发货",
            "blocked": "已阻止",
            "active": "激活",
            "pcs": "件数",
            "order-tag": "订单标记",
            "create-sku": "创建商品",
            "edit-sku": "编辑商品",
            "no-tags": "暂无标记订单",
            "order-tags": "订单标记",
            "delete-video": "删除视频",
            "video-proccesing": "视频正在处理中。",
            "please-check-later": "请稍后查看进度。",
            "note": "备注",
            "tags-are-active-at-delivery": "标签在交付时处于活动状态",
            "year": "年",
            "years": "年",
            "nfc-tags": "NFC标记",
            "quantity": "数量",
            "add-to-cart": "添加到购物车",
            "tag-type": "标记类型",
            "vat-not-included": "不含税",
            "cart": "在购物车中",
            "invalid-cart-item": "无效的购物车项目",
            "price-per-unit": "单价",
            "qty": "数量",
            "paid": "已支付",
            "sent": "已发送",
            "delivery": "发货",
            "state": "状态",
            "sent-to-production": "生产中",
            "uuid-loaded": "UIDS上传",
            "view": "浏览",
            "general": "总览",
            "slots": "位置",
            "statistics": "统计",
            "publish": "获得二维码链接",
            "publish-slot": "发布位置：月费",
            "date": "日期",
            "client": "客人",
            "location": "位置",
            "no-views": "无浏览",
            "color": "背景色",
            "text_color": "文字颜色",
            "white": "白色",
            "black": "黑色",
            "no-info": "此处暂无信息",
            "full-asset": "全部",
            "file": "文件",
            "view-file": "浏览文件",
            "delete-file": "删除文件",
            "unpublish": "不发布",
            "slot-pending-payment": "空位发布等待付款",
            "slot-name": "商品 {sku} 商品位置#：订单",
            "complete-the-payment": "支付 {price} 月费",
            "cancel": "取消",
            "pending_payment": "待支付",
            "sku-views": "商品浏览",
            "sku-count-change-thesame": "从上个月起无新的商品",
            "registered-skus": "已注册商品",
            "see-all": "浏览全部",
            "sku-count-change-decrease": "{change}% 和上月比较下降百分之",
            "sku-count-change-increase": "{change}% 和上月比较上升百分之",
            "total-views": "全部浏览",
            "views": "{count} 浏览次数",
            "active-slots": "{active} /{count} 位置",
            "email": "邮件",
            "tel": "电话",
            "download-image": "保存图片",
            "download-pdf": "保存PDF",
            "clone": "复制",
            "action-text": "文字",
            "assign_to_user": "将SKU分配给其他用户",
            "export-by-date": "按日期导出",
            "export-by-country": "按国家/地区导出",
            "ip": "IP地址",
            "country": "国家",
            "total-views_num": "{count} 统计全部浏览",
            "unique_views": "{count} 独立浏览",
            "sku_views": "单元商品浏览",
            "slot_views": "页面浏览",
            "download-eps": "保存为eps文件",
            "export-by-slot": "输出页面",
            "export": "输出",
            "publish_all_slots": "发表单元商品",
            "slots_published_success": "单元商品现在已经发布",
            "slots_published_error": "单元商品发布错误",
            "address": "地址",
            "txt": "文字",
            "ga_code": "谷歌分析",
            "slots-count": "页面统计",
            "remove_vertical_space": "页面垂直空间=0",
            "facebook": "脸书",
            "contact_email": "联系表格邮件",
            "contact_intro_text": "联系表格输入文字",
            "contact_visible": "显示联系表格",
            "contact_failed": "联系表格无法进行，请填写必须信息栏。",
            "disable_header": "题目无效",
            "keywords": "变换关键词",
            "retargeting_scripts": "重新指向原稿",
            "no-action": "无行动",
            "alt_text": "alt文本",
            "redirect": "隐藏单元商品（重新指向外部url）",
            "redirect_url": "重新指向url",
            "map": "地图",
            "views_chart": "浏览图表",
            "unique": "独立浏览",
            "daily-views": "每日浏览",
            "top-visitors": "最多浏览者",
            "visits": "浏览",
            "visitors": "浏览者",
            "views-map": "单元商品浏览地图",
            "show_ip": "显示ip地址",
            "hide_ip": "隐藏IP地址",
            "landing_page": "登陆页面",
            "landing_page_header": "登陆页面题目",
            "contact_landing_success": "表格已经成功提交。请检查您的邮箱，您会收到一个链接，点击链接可以看到详细单元商品信息。"
        },
        "pagination": {
            "previous": "&laquo; 前一个",
            "next": "下一个 &raquo;"
        },
        "mail": {
            "contact": {
                "success": "消息发送成功！"
            },
            "subjects": {
                "new-user": "新用户已注册",
                "new-user-to-manage": "新的管理账户",
                "approved-user": "微享平台-账户批准",
                "order-created": "新的订单已建立",
                "expiry_user_notify": "微享平台-订阅更新",
                "expiry_admin_notify": "微享平台去更新订阅",
                "sku-contact": "新的信息-单元商品{SKU}",
                "verify-email": "确认邮箱地址",
                "sku-landing-token": "确认邮箱地址"
            },
            "messages": {
                "registered": "使用电子邮件的新用户：电子邮件已注册到您的站点。",
                "user_to_manage": "一个新用户邮箱：邮箱已请求管理本账户",
                "approved-user": "您的粘糊目前已被激活。请登录平台。",
                "order-created": "一个新的订单已放置。",
                "expiry_user_notify": "您的单元商品的发布{SKU_code} 将于{due_date}过期。如果您希望继续发布，请进行支付延期，否则您的单元商品将无法自动发布。谢谢。",
                "expiry_admin_notify": "您的单元商品的发布{SKU_code} 将于{due_date}过期。如果您希望继续发布，请进行支付延期，否则您的单元商品将无法自动发布。谢谢。",
                "sku-contact-line1": "{name} 发送您信息",
                "verify-email-line1": "请点击下方按钮核实您的邮箱地址",
                "verify-email-line2": "系统 将批准您的账户，您将收到通知邮件，之后即可登录。",
                "verify-email-line3": "如果您未建立账户，无须其他操作。",
                "verify-email-button": "确认邮箱地址",
                "sku-landing-token-line1": "请点击下方按钮浏览更多信息关于{SKU}",
                "sku-landing-token-button": "好的"
            }
        },
        "routes": {
            "car": "建议",
            "terms-and-conditions": "条款",
            "privacy-policy": "保密条款",
            "raffle": "抽奖",
            "success": "成功",
            "offer-form": "提议表格",
            "contact-form": "算式-联系",
            "allow-cookie": "允许信息记录程序",
            "car-category": "类别"
        },
        "user": {
            "name": "名字",
            "email": "邮件",
            "created-date": "创建日期",
            "tags-ordered": "标记订单",
            "edit": "编辑",
            "new-user": "新用户",
            "no-users": "无用户",
            "impersionate": "代替操作",
            "delete": "删除",
            "user-created": "用户创建",
            "roles": "角色",
            "blocked-by": "您的帐户已被阻止：用户日期：。原因：：原因。",
            "blocked": "阻止",
            "clients": "客人",
            "administrators": "管理员",
            "user-blocked": "用户被阻止",
            "profile": "简介",
            "orders": "订单",
            "subscriptions": "订阅",
            "registered-users": "注册多用户",
            "count-users": "：计数用户",
            "count-change-thesame": "上个月没有新用户",
            "count-change-decrease": "从上个月起降低百分之",
            "count-change-increase": "从上个月起增加百分之",
            "SKU-count": "单元商品统计"
        },
        "validation": {
            "accepted": "{attribute} 必须接受属性。",
            "active_url": "{attribute} 属性不是有效的URL。",
            "after": "{attribute} 属性必须是 {date} 之后的日期。",
            "after_or_equal": "{attribute} 属性必须是晚于或等于 {date} 的日期。",
            "alpha": "{attribute} 属性只能包含字母。",
            "alpha_dash": "{attribute} 属性只能包含字母、数字、短划线和下划线。",
            "alpha_num": "{attribute} 属性只能包含字母和数字。",
            "array": "{attribute} 属性必须是数组。",
            "before": "{attribute} 属性必须是早于 {date} 的日期。",
            "before_or_equal": "{attribute} 属性必须是早于或等于{date} 的日期。",
            "between": {
                "numeric": "{attribute} 属性必须介于 {min} 最小量和 {max} 最大量之间。",
                "file": "{attribute} 属性必须介于 min 最小和 {max} 最大字节之间。",
                "string": "{attribute} 属性必须介于 min 最少的和 {max} 最多的字符之间。",
                "array": "{attribute} 属性必须具有介于 min 和 {max} 之间的项。"
            },
            "boolean": "{attribute} 属性字段必须为TRUE或FALSE。",
            "confirmed": "{attribute} 属性确认不匹配。",
            "date": "{attribute} 属性不是有效日期。",
            "date_equals": "{attribute} 属性必须是等于：Date的日期。",
            "date_format": "{attribute} 属性与 {format} 不匹配。",
            "different": "{attribute} 属性和 {other} 必须不同。",
            "digits": "{attribute} 属性必须是 digits位数。",
            "digits_between": "{attribute} 属性必须介于 min 和 {max} 位数之间。",
            "dimensions": "{attribute} 属性具有无效的图像维度。",
            "distinct": "{attribute} 属性字段具有重复值。",
            "email": "{attribute} 属性必须是有效的电子邮件地址。",
            "ends_with": "{attribute} 属性必须以以下值之一结束 {values}",
            "exists": "{attribute} 属性无效。",
            "file": "{attribute} 属性必须是文件。",
            "filled": "{attribute} 属性字段必须具有值。",
            "gt": {
                "numeric": "{attribute} 属性必须大于 {value} 值。",
                "file": "{attribute} 属性必须大于 {value} 值千字节。",
                "string": "{attribute} 属性必须大于 value 值字符。",
                "array": "{attribute} 属性必须具有多于 {value} 值项。"
            },
            "gte": {
                "numeric": "{attribute} 属性必须大于或等于 {value} 值。",
                "file": "{attribute} 属性必须大于或等于 {value} 值千字节。",
                "string": "{attribute} 属性必须大于或等于 {value} 值字符。",
                "array": "{attribute} 属性必须具有 {value} 项或更多项。"
            },
            "image": "{attribute} 属性必须是图像。",
            "in": "{attribute} 属性无效。",
            "in_array": "{other} 中不存在 {attribute} 字段。",
            "integer": "{attribute} 属性必须是整数。",
            "ip": "{attribute} 属性必须是有效的IP地址。",
            "ipv4": "{attribute} 属性必须是有效的IPv4地址。",
            "ipv6": "{attribute} 属性必须是有效的IPv6地址。",
            "json": "{attribute} 属性必须是有效的JSON字符串。",
            "lt": {
                "numeric": "{attribute} 属性必须小于 {value} 值。",
                "file": "{attribute} 属性必须小于 {value} 值千字节。",
                "string": "{attribute} 属性必须少于 {value} 值字符。",
                "array": "{attribute} 属性必须具有小于 {value} 值项。"
            },
            "lte": {
                "numeric": "{attribute} 属性必须小于或等于 {value} 值。",
                "file": "{attribute} 属性必须小于或等于 {value} 值千字节。",
                "string": "{attribute} 属性必须小于或等于 {value} 值字符。",
                "array": "{attribute} 属性不能有超过 {value} 值项。"
            },
            "max": {
                "numeric": "{attribute} 属性不能大于 {max}。",
                "file": "{attribute} 属性不能大于 {max} 最大千字节。",
                "string": "{attribute} 属性不能大于 {max} 最大字符数。",
                "array": "{attribute} 属性的项数不能超过 {max}。"
            },
            "mimes": "{attribute} 属性必须是类型为：{values} 的文件。",
            "mimetypes": "{attribute} 属性必须是类型为：{values} 的文件。",
            "min": {
                "numeric": "{attribute} 属性必须至少为 {min}。",
                "file": "{attribute} 属性必须至少为 {min} 最小千字节。",
                "string": "{attribute} 属性必须至少包含 {min} 个字符。",
                "array": "{attribute} 属性必须至少有 {min} 项。"
            },
            "not_in": "{attribute} 属性无效。",
            "not_regex": "{attribute} 属性格式无效。",
            "numeric": "{attribute} 属性必须是数字。",
            "present": "{attribute} 属性字段必须存在。",
            "regex": "{attribute} 属性格式无效。",
            "required": "{attribute} 字段是必需的。",
            "required_if": "当 {other} 为 {value} 时，需要 {attribute} 字段。",
            "required_unless": "除非 {other} 位于 {values} 中，否则 {attribute} 字段是必需的。",
            "required_with": "如果存在 {values}，则需要 {attribute}字段。",
            "required_with_all": "当{values} 值存在时，{attribute} 属性字段是必需的。",
            "required_without": "当 {Values}不存在时，需要 {attribute}字段。",
            "required_without_all": "当不存在任何 {values} 值时，需要 {attribute}字段。",
            "same": "{attribute} 属性和：other必须匹配。",
            "size": {
                "numeric": "{attribute} 属性必须为：Size。",
                "file": "{attribute} 属性必须为 {size} KB。",
                "string": "{attribute} 属性必须是 {size} 大小字符。",
                "array": "{attribute} 属性必须包含 {size} 项。"
            },
            "starts_with": "{attribute} 属性必须以以下值之一开头 {values}",
            "string": "{attribute} 属性必须是字符串。",
            "timezone": "{attribute} 属性必须是有效区域。",
            "unique": "{attribute} 属性已被获取。",
            "uploaded": "{attribute} 属性上载失败。",
            "url": "{attribute} 属性格式无效。",
            "uuid": "{ATTRIBUTE} 必须是有效的UID。",
            "custom": {
                "attribute-name": {
                    "rule-name": "自定义-消息"
                }
            }
        },
        "shop": []
    },
    "de": {
        "register": [],
        "settings": [],
        "subscription": [],
        "cart": [],
        "subscription-product": [],
        "common": [],
        "prices": [],
        "invoice": [],
        "auth": [],
        "pages": {
            "home": [],
            "contact": []
        },
        "sku": [],
        "mail": [],
        "routes": [],
        "user": []
    },
    "en": {
        "register": {
            "title": "Register for a new account",
            "firstName": "First name",
            "lastName": "Last name",
            "email": "E-mail",
            "password": "Password",
            "confirmPassword": "Confirm Password",
            "companyName": "Company name",
            "companyRegistrationNumber": "Company registration number",
            "address": "Address",
            "city": "City",
            "postalCode": "Postal code",
            "country": "Country",
            "industry": "Industry",
            "position": "Position",
            "phoneNumber": "Phone number",
            "manageAccount": {
                "help": "admin will upload your videos, subtitles, images & countries"
            },
            "manageAccount.help": "admin will upload your videos, subtitles, images & countries",
            "register-button": "Register",
            "managedAccount": "I allow admin to manage my account. Charged only in months with activity",
            "allow-admin-to-manage-account": "admin will upload your videos, images and other info",
            "acceptTerms": "I accept terms & conditions",
            "acceptNewsletter": "I accept to receive VOYPP news",
            "login": "Login",
            "success": "Register successful",
            "success-text": "Please check your inbox and confirm your e-mail address. After confirmation, wait until the administrator will approve your account. Then, you'll be notified by e-mail and you'll be able to login. Thank you!",
            "success-verified": "Please wait until the administrator will approve your account. Then, you'll be notified by e-mail and you'll be able to login. Thank you!",
            "approved": "Approved by admin",
            "county": "County",
            "company_data_required": "Company information is required"
        },
        "settings": {
            "slot-subscription-price": "Slot subscription price",
            "slot-subscription-vat": "Slot subscription VAT",
            "slot-subscription-discount": "Slot subscription discount",
            "slot-subscription-price-day-threshold": "Slot price for daily threshold",
            "not-defined": "Setting {setting} not defined",
            "managed_user_account_subscription_product": "Managed user account subscription plan",
            "mail_new_account_registered": "E-mail - new account redistered",
            "mail_new_manage_account_subscription": "E-mail - new managed account subscription",
            "mail_new_tags_order": "E-mail - new tags order",
            "mail_new_transaction_success": "E-mail - new successful transaction_",
            "mail_failed_transaction": "E-mail - failed transaction",
            "max_sku_slots": "Max. SKU slots",
            "max_chars_title_subtitle": "Max. chars. title / subtitle",
            "max_chars_sku_description": "Max. chars. SKU description",
            "mail_expiry_sku": "E-mail - SKU is about to expire"
        },
        "order": {
            "orders": "Orders",
            "order": "Order",
            "id": "#ID",
            "date": "Date",
            "status": "State",
            "quantity": "Quantity",
            "total": "Total",
            "no-items": "No orders",
            "subscriptions": "Subscriptions",
            "name": "Name",
            "created_on": "Created on",
            "due_date": "Due date",
            "price-per-month": "Price per month",
            "price": "Price",
            "view": "View",
            "unsubscribe": "Unsubscribe",
            "invoices": "Invoices",
            "no-invoices": "No invoices",
            "lines": "Lines",
            "download-pdf": "Download PDF",
            "paid-at": "Paid at",
            "summary": "Order summary",
            "manual_pay": "Payment will be processed manually",
            "manual_pay_pending": "Manual payment pending",
            "manage_plan": "Manage",
            "finish_order": "Finish order",
            "successful_order": "Finish order",
            "order_shipping_soon": "Your order has been confirmed and will be shipping soon.",
            "order_confirmation": "Order confirmation",
            "thanks": "Thank you!",
            "sales": "Shop Sales",
            "ref-num": "Reference id number",
            "payment-identifier": "Payment Id",
            "no-payments": "No payments",
            "envelops": "Envelops",
            "parcels": "Parcels",
            "weight_kg": "Weight (kg)",
            "length": "Length (cm)",
            "width": "Width (cm)",
            "height": "Height (cm)",
            "netopia_noua": "New",
            "netopia_deschisa": "Open",
            "netopia_platita": "Paid",
            "netopia_confirmata": "Confirmed",
            "netopia_anulata": "Canceled",
            "netopia_in_asteptare": "On Hold",
            "netopia_in_verificare": "Checking",
            "netopia_creditata": "Credited",
            "wrong_amount": "The amount paid is not the same as the total order amount",
            "paid_nedd_shipping": "The order is paid and needs to be shipped",
            "paid_completed": "The order is paid and is complete",
            "payment_processed": "Your payment is currently being processed",
            "payment_nedd_captured": "Payment remotely accepted, make sure to capture it",
            "payment_not_received": "The transaction wasn't successful, payment wasn't received.",
            "payment_refund": "The payment was refunded.",
            "payment_wrong_args": "The payment gateway posted invalid parameters.",
            "payment_invalid_action": "The payment gateway posted invalid action",
            "payment_will_process": "Your payment will be processed. Shortly, you will receive a confirmation e-mail."
        },
        "passwords": {
            "password": "Passwords must be at least eight characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "profile": {
            "my-account": "My account",
            "account-details": "Account details",
            "change-password": "Change password",
            "old-password": "Old password",
            "new-password": "New password",
            "new-password-confirm": "Confirm password",
            "account-deleted": "Account deleted",
            "password-changed": "Password changed",
            "incorrect-old-password": "Incorrect old password",
            "profile-updated": "Profile updated",
            "email-taken": "e-mail registered with another account",
            "edit-profile": "Edit profile",
            "blocked-by": "Account was blocked by {user} on {date}",
            "account-status": "Account status",
            "block-user": "Block user",
            "block-user-confirm": "Explain message",
            "reason": "Reason",
            "unblock-user": "Unblock user",
            "account-role": "Account role",
            "save-role": "Save role",
            "maximum_slots": "Maximum allowed slots"
        },
        "subscription": {
            "new-subscription": "New Subscription",
            "select": "Select",
            "subscribe-plan": "Subscribe for {price} per month",
            "subscribe": "Subscribe",
            "create-invoice": "Create invoice"
        },
        "cart": {
            "go-to-cart": "Cart ({items} pcs.)",
            "added": "Cart update",
            "sku": "SKU",
            "type": "Type",
            "quantity": "Quantity",
            "unit-price": "Unit price",
            "subtotal": "Subtotal",
            "total": "Total",
            "pcs": "pcs.",
            "no-items": "No items",
            "cart": "Cart",
            "year": "year",
            "years": "years",
            "checkout": "Checkout",
            "invoice-details": "Invoice details",
            "vat-not-included": "VAT not included",
            "name": "Name",
            "shipping-details": "Shipping details",
            "copy-from-invoice-details": "Copy from invoice details",
            "no-items-in-cart": "Can not go to checkout as there are no items in the cart",
            "pending": "Pending",
            "complete": "Complete",
            "shipped": "Shipped",
            "invoice": "Invoice",
            "shipping": "Shipping",
            "place-order": "Place order",
            "order-placed": "Order placed successfully",
            "product": "Product",
            "update": "Update",
            "updated": "Cart updated",
            "redirecting-to-payment": "Redirecting to payment",
            "payment-received": "Payment received",
            "to_be_shipped": "To be shipped",
            "refunded": "Refunded",
            "canceled": "Canceled",
            "refused": "Refused",
            "not-compatible": "This item is not compatible with existing items in cart because it uses different currency or payment method. Please order this item separately.",
            "review-cart": "Cart review",
            "product-not-for-sale": "Product Not Available!",
            "reviewcart-contents": "Please Review your shopping cart contents",
            "failed": "Failed",
            "on_hold": "On Hold"
        },
        "subscription-product": {
            "create": "Create",
            "name": "Name",
            "price": "Price",
            "vat": "VAT (%)",
            "no-content": "No items",
            "edit": "Edit",
            "delete": "Delete",
            "subscription-products": "Subscription plans",
            "cant-delete-managed-account-subscription": "Can not delete the managed account subscription. First change it in settings.",
            "draft": "Draft",
            "published": "Published",
            "pending_payment": "Pending payment",
            "description": "Description",
            "months": "Months"
        },
        "order-history": {
            "date": "Date",
            "author": "Author",
            "content": "Content",
            "post": "Post message"
        },
        "common": {
            "voypp": "voypp",
            "tagline": "video on your product platform",
            "home": "Home",
            "terms-and-conditions": "Terms and conditions",
            "welcome": "Welcome",
            "filter": "Filter",
            "search": "Search…",
            "reset": "Reset",
            "previous": "Previous",
            "next": "Next",
            "pagination-summary": "Showing {perPage} items, from a total of {total}",
            "menu": {
                "about": "about Voypp",
                "how-it-works": "how it works",
                "prices": "prices",
                "join-the-platform": "join the platform",
                "contact": "contact",
                "login": "login",
                "register": "register",
                "dashboard": "Dashboard",
                "logout": "logout"
            },
            "administration": "Administration",
            "users": "Users",
            "tags": "Tags",
            "tag-prices": "Tag prices",
            "content": "Content",
            "translations": "Translations",
            "close": "Close",
            "save": "Save",
            "non-empty-html": "The {attribute} must not be empty",
            "are-you-sure": "Are you sure you want to do this?",
            "save-error-title": "Error saving data",
            "generic-error": "Something went wrong. Please check bellow.",
            "impersonating": "You are impersonating this user.",
            "impersonating-stop": "Return back",
            "copyright-protected": "copyright protected",
            "powered-by": "powered by",
            "trashed": "Trashed",
            "with-trashed": "With trashed",
            "only-trashed": "Only trashed",
            "no-trashed": "Exclude trashed",
            "yes": "Yes",
            "no": "No",
            "back": "Back",
            "pcs": "pcs.",
            "delete": "Delete",
            "all": "All",
            "data-saved": "Data saved",
            "no-items": "No items",
            "parameter-must-be-a-list": "Parameter {attribute} must be a list",
            "locale-not-set": "Locale {locale} for parameter {attribute} is not set",
            "page": "Page",
            "widget": "Widget",
            "platform": "Platform",
            "video": "Video on Voypp server",
            "vimeo": "Video on external server",
            "image": "Image",
            "privacy-policy": "Privacy policy",
            "monthly-subscription": "Monthly subscription to {product}",
            "subscription-to": "Subscription to {product}",
            "payment-successful": "Payment successful",
            "pending-payment": "Pending payment",
            "payment-error": "Payment error",
            "paid": "Paid",
            "overdue": "Overdue",
            "canceled": "Canceled",
            "draft": "Draft",
            "invoices": "Invoices",
            "cancel": "Cancel",
            "settings": "Settings",
            "ok": "ok",
            "dashboard": "Dashboard",
            "subscription-plans": "Subscription plans",
            "subscription-plan": "Subscription plan",
            "pay-now": "Pay now",
            "order": "Order",
            "menu-footer": {
                "facebook": "Facebook",
                "newsletter": "newsletter",
                "e-mail": "e-mail",
                "contact": "contact",
                "gdpr": "GDPR",
                "terms-and-conditions": "terms and conditions",
                "login": "Login"
            },
            "mail-recommendation-subject": "Recommendation",
            "mail-recommendation-body": "I recommend this page: {appURL}",
            "mail-recommendation-title": "Recommendation by e-mail",
            "fb-share-title": "Share on Facebook",
            "sku-mail-recommendation-body": "I found some interesting information about {producer} {brand}: {appURL}",
            "sku-fb-recommendation-body": "I found some interesting information about {producer} {brand}: {appURL}",
            "share": "Share",
            "follow": "Follow",
            "top": "Top",
            "cookie": {
                "consent_text": "This microsite use cookies to personalize your experience and understand how people are using our services, for future improvement.",
                "uses_cookies": "This microsite uses cookies",
                "only_required": "Allow essential",
                "allow_all": "Allow all",
                "view_all": "View all cookies",
                "used": "Cookies used by this microsite",
                "name": "Name",
                "description": "Description",
                "no_cookie": "No cookies",
                "loading": "Loading...",
                "reject": "Reject all"
            },
            "example": "Ex.",
            "word": "word",
            "submit": "Submit",
            "carousel": "Carousel",
            "instagram-share-title": "Share on Instagram",
            "telegram-share-title": "Share on Telegram",
            "whatsapp-share-title": "Share on Whatsapp",
            "weechat-share-title": "Share on Wechat",
            "captcha-required": "Please verify that you are not a robot.",
            "captcha-error": "Captcha error! try again or contact site admin.",
            "return-policy": "Return policy",
            "customer-name": "Customer name",
            "error-terms": "You must agree to the terms and conditions!",
            "contact-list": "Contact list",
            "generic_problem": "Oops, There is a problem!"
        },
        "prices": {
            "prices": "Prices",
            "configure-title": "Configure prices",
            "explain": "Start by adding in all the possible tag types and all the min prices variants.",
            "types": "Types",
            "min-quantity": "Min. quantity",
            "add-new-type": "Add new type",
            "add-new-year": "Add new year",
            "add-new-min-quantity": "Add new min quantity",
            "type": "Type",
            "year": "year",
            "quantity": "Quantity",
            "delete": "Delete",
            "no-types": "No types defined yet. Add one using the form above.",
            "no-years": "No years defined yet. Add one using the form above.",
            "no-min-quantity": "No min quantity defined yet. Add one using the form above.",
            "save-configuration": "Save configuration",
            "configuration-saved": "Configuration saved",
            "years": "years",
            "prices-input-not-a-list": "{attribute} is not a list of prices",
            "price-does-not-have-a-type-set": "{attribute} has a price with a missing type variable",
            "price-does-not-have-a-year-set": "{attribute} has a price with a missing year variable",
            "price-does-not-have-a-quantity-set": "{attribute} has a price with a missing quantity variable",
            "price-does-not-have-a-price-set": "{attribute} has a price with a missing price variable",
            "tag-prices": "Tag prices"
        },
        "invoice": {
            "invoice": "Invoice",
            "vat": "VAT",
            "date": "Date",
            "due_date": "Due date",
            "product": "Product",
            "quantity": "Quantity",
            "rate": "Rate",
            "subtotal": "Subtotal",
            "total": "Total",
            "from": "From",
            "to": "To",
            "name": "Name",
            "company": "Company",
            "address": "Address",
            "this-month-income": "This month income",
            "income-change-thesame": "No change from last month",
            "income-change-decrease": "{change}% decrease since last month",
            "income-change-increase": "{change}% increase since last month",
            "description": "Description",
            "amount": "Amount",
            "price_unit": "Unit. price",
            "discount": "Discount",
            "total_net": "Total net",
            "base": "Base",
            "disclaimer_title": "Notes & information:",
            "disclaimer_line1": "This invoice is automatically canceled, including the offer, if not paid within 5 working days from issuance date, if no other term stipulated in the contract. This invoice must be provided for any claims and warranty purposes.",
            "disclaimer_line2": "For more informations, go to www.voypp.com.",
            "disclaimer_line3": "Thank you for choosing VOYPP.",
            "paid_at": "Paid at:",
            "demo": "DEMO",
            "this-month-sales": "This month sales",
            "income-previous-empty": "No sales in previus month."
        },
        "content": {
            "title": "Title",
            "created-date": "Created at",
            "no-content": "No content",
            "create": "Create",
            "content": "Content",
            "edit": "Edit",
            "type": "Type",
            "slug": "Slug",
            "slug-taken": "Slug already used",
            "preview": "Preview",
            "delete": "Delete",
            "content-deleted": "Content deleted"
        },
        "translations": {
            "id": "ID",
            "save_error_title": "Error saving translation"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "login-title": "Login",
            "login-button": "Login",
            "logout-button": "Log out",
            "forgot-password-link": "Forget password?",
            "remember": "Remember me",
            "register-title": "Register",
            "register-button": "Register here",
            "login-text": "Already have an account?",
            "register-text": "Need an account?",
            "password": "Password",
            "email": "E-mail",
            "profile": "Profile",
            "verify-your-email-address": "Verify Your Email Address",
            "verify-check-email": "Before proceeding, please check your email for a verification link.",
            "resend-verification-email": "Resend verification email",
            "verification-ok": "Email verification OK.",
            "verification-resent": "A fresh verification link has been sent to your email address.",
            "resetPass": "Reset Password",
            "confirmPassword": "Confirm Password",
            "account_not_activated": "Your account is not approved by the admin. Please wait until you will receive the confirmation e-mail.",
            "reset-success": "Password successfully changed!"
        },
        "pages": {
            "home": {
                "title": "NFC/QR VOYPP® Powered Products",
                "subtitle": "Put your creativity at work and talk to the customers directly through your product, wherever they meet it.",
                "about": {
                    "title": "About VOYPP®",
                    "content": "VOYPP® is the first NFC/QR automated DTC/CTP (Direct-To-Consumer / Communicate Through Product) platform to deliver relevant information at shelf or anywhere else the customer may be in direct contact with the product. <br/> Scan the NFC tag/QR code and get instant access to the product's panel displaying up to 10 short relevant videos or graphics. Find active promotions or other essential information."
                },
                "how-it-works": {
                    "title": "How It Works",
                    "content": "You are a consumer and found a product/service with a Voypp NFC tag or QR code? Enable your mobile NFC function and touch with the mobile the tag on the product or scan the QR code. Open the panel and choose the video you want to watch. Short videos around 1 minute will explain you the essential about chosen topic. Find promotions available on your area. You and the product. Experienced content creators will drive you to better evaluate the product/service."
                },
                "prices": {
                    "title": "Prices",
                    "content": "Starting from as low as 0,15 euro, up to 5.04 euro per NFC tag, varying upon the quantity. Additionally, you can order special shapes or graphics, tags for special purposes, as for metallic support or combined tags NFC + RFID. Meantime, you are free to produce the NFC tags or QR code labels by yourself, in such case you can use the platform paying only the active slots, 5 euro/slot/month. We can manage your account for 25 euro/month, regardless the number of the SKU's. VAT not included."
                },
                "join": {
                    "title": "Join The Platform",
                    "content": "<p>You are a producer and want to join our platform? Sign in and publish your SKU there. Decide the necessary quantity of NFC tags/QR code labels, create and upload the content. This is all you need to do. We manage the rest. Your tags can be accessed anywhere in World (including China). Scan the below QR code with your mobile and see how looks and how function a product page.</p>",
                    "button": "sign in"
                },
                "join.button": "sign in",
                "tagline": "video on your product platform"
            },
            "contact": {
                "title": "Contact form",
                "full_name": "Full name",
                "full_name_placeholder": "Type your full name",
                "email": "E-mail",
                "email_placeholder": "Type your e-mail address",
                "message": "Message",
                "message_placeholder": "Type your message",
                "phone_placeholder": "Type your phone number",
                "city_placeholder": "City",
                "phone": "Telephone",
                "city": "City",
                "submit": "Submit message",
                "mandatory_fields": "Mandatory field",
                "contact-deleted": "Content deleted",
                "buyer": "Buyer",
                "incomplete_order": "Incomplete order"
            }
        },
        "sku": {
            "sku-list": "SKU list",
            "order-new-sku": "Order new SKU",
            "prices": "Prices",
            "code": "Code",
            "description": "Description",
            "tags-ordered": "Tags ordered",
            "created-date": "Created date",
            "no-skus": "No SKUs defined",
            "order": "Order",
            "sku": "SKU",
            "edit": "Edit",
            "order-labels": "Order labels",
            "analytics": "Analytics",
            "new-sku": "New SKU",
            "edit-sku-information": "Edit SKU information",
            "save": "Save",
            "code-explain": "3 characters + 2 digits",
            "slot": "SKU Slot",
            "add-slot": "Add slot",
            "remove-slot": "Remove slot",
            "video": "Video",
            "image": "Image",
            "producer": "Producer",
            "brand": "Brand",
            "video-file": "Video file",
            "video-file-help": "load video max. 400Mb",
            "image-file": "Image file",
            "image-file-help": "(.jpg, .png, .gif files, max. 2Mb)",
            "media-type": "Media type",
            "preview": "Preview",
            "action": "Action",
            "url": "Url",
            "saving-title": "Saving SKU",
            "delete": "Delete",
            "title": "Title",
            "title-help": "max. 25 characters title + subtitle",
            "subtitle": "Subtitle",
            "characters-remaining": "Content character remaing:",
            "uploading": "Uploading, please do not close this window until the transfer is complete.",
            "video-will-be-loaded-soon": "A video will be loaded here soon. Please check again later.",
            "live-url": "Live URL",
            "no-live-url-yet": "As soon as you order at least one tag, the URL will be visible.",
            "views-count": "Views count",
            "current-image": "Current image",
            "delete-image": "Delete image",
            "draft": "Draft",
            "published": "Published",
            "tags": "Tags",
            "tags-orderd-pcs": "Tags ordered pcs.",
            "order-date": "Order date",
            "delivery_date": "Delivery date",
            "status": "Status",
            "uid-loaded": "UID load",
            "unit-price": "Unit price",
            "total": "Total views",
            "active-blocked": "Active / blocked",
            "pending": "Pending",
            "in_production": "In production",
            "delivered": "Delivered",
            "blocked": "blocked",
            "active": "active",
            "pcs": "pcs.",
            "order-tag": "Order tag",
            "create-sku": "Create SKU",
            "edit-sku": "Edit SKU",
            "no-tags": "No tags ordered yet",
            "order-tags": "Order tags",
            "delete-video": "Delete video",
            "video-proccesing": "The video is processing.",
            "please-check-later": "Please check later for progress.",
            "note": "Note",
            "tags-are-active-at-delivery": "Tags are active at delivery",
            "year": "year",
            "years": "years",
            "nfc-tags": "NFC tags",
            "quantity": "Quantity",
            "add-to-cart": "Add to cart",
            "tag-type": "Tag type",
            "vat-not-included": "VAT not included",
            "cart": "In shopping cart",
            "invalid-cart-item": "Invalid cart item",
            "price-per-unit": "Price per unit",
            "qty": "qty",
            "paid": "Paid",
            "sent": "sent",
            "delivery": "delivery",
            "state": "State",
            "sent-to-production": "Sent to production",
            "uuid-loaded": "UIDs loaded",
            "view": "View",
            "general": "General",
            "slots": "Slots",
            "statistics": "Statistics",
            "publish": "Get the QR link",
            "publish-slot": "Publish slot for {price} per month",
            "date": "Date",
            "client": "Client",
            "ip": "IP",
            "country": "Country",
            "location": "Location",
            "no-views": "No views",
            "color": "Background Color",
            "text_color": "Text Color",
            "white": "White",
            "black": "Black",
            "no-info": "No information here yet.",
            "full-asset": "Full",
            "file": "File",
            "view-file": "View file",
            "delete-file": "Delete file",
            "unpublish": "Unpublish",
            "slot-pending-payment": "Slot publishing pending payment",
            "slot-name": "SKU {sku} slot #{order}",
            "complete-the-payment": "Pay {price} per month",
            "cancel": "Cancel",
            "pending_payment": "Pending payment",
            "sku-views": "SKU Views",
            "sku-count-change-thesame": "No new skus from last month",
            "registered-skus": "Registered SKUs",
            "see-all": "See all",
            "sku-count-change-decrease": "{change}% decrease since last month",
            "sku-count-change-increase": "{change}% increase since last month",
            "total-views": "Total views",
            "total-views_num": "{count} total views",
            "views": "{count} views",
            "unique_views": "{count} unique views",
            "sku_views": "SKU views",
            "slot_views": "Slot views",
            "active-slots": "{active} / {count} slots",
            "email": "E-mail",
            "tel": "Telephone",
            "download-image": "Save as image",
            "download-pdf": "Save as pdf",
            "download-eps": "Save as eps",
            "clone": "Clone",
            "action-text": "Text",
            "assign_to_user": "Assign SKU to another user",
            "export-by-date": "Export by date",
            "export-by-country": "Export by country",
            "export-by-slot": "Export by slot",
            "export": "Export",
            "publish_all_slots": "Publish SKU",
            "slots_published_success": "SKU is now published.",
            "slots_published_error": "SKU publishing error.",
            "address": "Address",
            "txt": "Text",
            "ga_code": "Google Analytics",
            "slots-count": "Slots Count",
            "remove_vertical_space": "Vertical space between slots = 0",
            "facebook": "Facebook",
            "contact_email": "Contact form e-mail",
            "contact_intro_text": "Contact form intro text",
            "contact_title": "Form title",
            "contact_form_type": "Form type",
            "disable_captcha": "Disable captcha",
            "contact_form_type_contact": "Contact Form",
            "contact_form_type_custom": "Custom Form",
            "contact_form_fields": "Custom Form Fields",
            "contact_visible": "Display contact form",
            "contact_failed": "The contact form can't be processed. Please fill in the mandatory fields!",
            "disable_header": "Disable header",
            "keywords": "Meta Keywords",
            "retargeting_scripts": "Retargeting Scripts",
            "no-action": "No Action",
            "alt_text": "Alt text",
            "redirect": "Hidden SKU (redirect to external URL)",
            "redirect_url": "Redirect to URL",
            "map": "Map",
            "views_chart": "Views Chart",
            "unique": "Unique views",
            "daily-views": "Daily views",
            "top-visitors": "Top visitors",
            "visits": "Visits",
            "visitors": "Visitors",
            "views-map": "SKU views map",
            "show_ip": "Display IP",
            "hide_ip": "Hide IP",
            "landing_page": "Landing page",
            "landing_page_header": "Landing page header",
            "contact_landing_success": "The form has been successfully submitted. Please check your e-mail, where you can find a link, which will allow you to see more info regarding our SKU.",
            "add-field": "Add Field",
            "customer_mail_intro_text": "Customer mail intro text",
            "category": {
                "name": "Folder name",
                "add": "Add folder",
                "delete": "Delete folder",
                "removed": "The folder was successfully removed!"
            },
            "category.removed": "The folder was successfully removed!",
            "whatsapp": "Whatsapp",
            "telegram": "Telegram",
            "messenger": "Messenger",
            "weechat": "Wechat",
            "instagram": "Instagram",
            "allow_pan": "Allow pan",
            "width": "Width",
            "disable_whatsapp_share": "Disable Whatsapp share",
            "disable_instagram_share": "Disable Instagram share",
            "disable_telegram_share": "Disable Telegram share",
            "disable_weechat_share": "Disable Wechat share",
            "disable_facebook_share": "Disable Facebook share",
            "disable_email_share": "Disable email share",
            "weechat-share-text": "Scan \"QR Code\" in Wechat and press {icon} to share!",
            "domains": "Domains",
            "domain_name": "Domain name",
            "is_domain_active": "Enable domain",
            "save_domains": "Save",
            "max_slots": "User has exceeded the maximum number of slots!",
            "autoplaySpeed": "Carousel autoplay speed",
            "shop": "Shop",
            "auto_play": "Auto play",
            "buy_button_text_color": "Buy button - text color",
            "buy_button_background_color": "Buy button - background color",
            "no_horizontal_space": "Remove horizontal space",
            "top_sku_views": "Top Sku views"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "mail": {
            "contact": {
                "success": "Message was successfully sent!"
            },
            "subjects": {
                "new-user": "New User Registered",
                "new-user-to-manage": "New managed account",
                "approved-user": "Voypp - Account approved",
                "order-created": "Order confirmation",
                "expiry_user_notify": "Voypp - Subscription renewal",
                "expiry_admin_notify": "Voypp Subscription to renew",
                "sku-contact": "New message - SKU {SKU}",
                "verify-email": "Confirm Email Address",
                "sku-landing-token": "Confirm Email Address",
                "sku-custom-form": "New form data - SKU {SKU}",
                "sku-custom-form-customer": "Data confirmation for SKU {SKU}",
                "succesful_payment_admin_notify": "Voypp - new payment",
                "succesful_payment_buyer_notify": "New payment",
                "bank_transfer_info": "Bank transfer - information"
            },
            "messages": {
                "registered": "A new user with e-mail {email} has registered to your site.",
                "user_to_manage": "A new user with e-mail {email} has solicited to managed the account.",
                "approved-user": "Your account is now activated by the admin. Please login to our platform.",
                "order-created": "A new order was placed.",
                "expiry_user_notify": "The publishing of your SKU {SKU_code} will expire on {due_date}. If you want continue publishing it, please proceed the payment for desired period, otherwise, your SKU will be unpublished automatically. Thank you!",
                "expiry_admin_notify": "The publishing of your SKU {SKU_code} will expire on {due_date}. If you want continue publishing it, please proceed the payment for desired period, otherwise, your SKU will be unpublished automatically. Thank you!",
                "sku-contact-line1": "{name} sent you a message.",
                "verify-email-line1": "Please click the button below to verify your email address.",
                "verify-email-line2": "The administrator will approve your account, you will be notified by e-mail, after that you will be able to login.",
                "verify-email-line3": "If you did not create an account, no further action is required.",
                "verify-email-button": "Confirm Email Address",
                "sku-landing-token-line1": "Please click the button below to view more details about {SKU}.",
                "sku-landing-token-button": "OK",
                "sku-custom-form-line1": "You have received new data for: \"{formTitle}\"",
                "sku-custom-form-customer-line1": "You have submited following informations:",
                "succesful_payment_admin_notify": "The payment for order #{orderId} was registered!",
                "succesful_payment_buyer_notify": "The payment for order #{orderId} was registered!",
                "thank-you-order": "Thank you for your order!",
                "thank-you-for-buying": "Thank you for buying from {storeName}!",
                "payment-value-admin": "A payment of {value}{currency} was registered  for order #{orderId}!",
                "payment-value-buyer": "A payment of {value}{currency} was successfully registered for your order #{orderId}!",
                "hello": "Hello {name}",
                "follow-order-link": "You can follow your order at this link:",
                "download-invoice-link": "You can download your invoice at this link:",
                "bank_transfer_info_": ""
            }
        },
        "routes": {
            "car": "offer",
            "terms-and-conditions": "Terms & conditions",
            "privacy-policy": "Confidentiality policy",
            "raffle": "Lucky draw",
            "success": "succes",
            "offer-form": "Offer form",
            "contact-form": "Contact form",
            "allow-cookie": "allow cookie",
            "car-category": "category"
        },
        "user": {
            "name": "Name",
            "email": "E-mail",
            "created-date": "Created date",
            "tags-ordered": "Tags ordered",
            "edit": "Edit",
            "new-user": "New user",
            "no-users": "No users",
            "impersionate": "Impersonate",
            "delete": "Delete",
            "user-created": "User created",
            "roles": "Roles",
            "blocked-by": "Your account has been blocked by {user} on {date}. Reason: {reason}.",
            "blocked": "Blocked",
            "clients": "Clients",
            "administrators": "Administrators",
            "user-blocked": "User has been blocked",
            "profile": "Profile",
            "orders": "Orders",
            "subscriptions": "Subscriptions",
            "registered-users": "Registered users",
            "count-users": "{count} users",
            "count-change-thesame": "No new users from last month",
            "count-change-decrease": "{change}% decrease since last month",
            "count-change-increase": "{change}% increase since last month",
            "SKU-count": "SKU count",
            "confirmAccount": "Confirm Account",
            "confirmedSince": "Confirmed since {date}"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "shop": {
            "disabled": "Disabled",
            "enabled": "Enabled",
            "out_of_stoc": "Out of stock",
            "in_stoc": "In stock",
            "currency": "Currency",
            "paymentMethods": "Payment methods",
            "paymentMethod": "Payment method",
            "shippingMethods": "Shipping methods",
            "shippingMethod": "Shipping method",
            "choose-shipping-method": "Choose shipping method",
            "choose-payment-method": "Choose payment method",
            "buy-now": "Buy now",
            "shopping-cart": "Shopping cart",
            "shopping-cart-empty": "Your shopping cart is empty!",
            "ship-tax-info": "Shipping will be calculated at checkout.",
            "items-in-cart": "Items in your shopping cart",
            "remove": "Remove",
            "remove-item-error": "Cannot remove item from cart",
            "invoicing-address": "Billing address",
            "invoicing-info": "Billing information",
            "shipping-address": "Shipping address",
            "shipping-updates": "Shipping updates",
            "shipping-cost": "Shipping cost",
            "not-charget-yet": "You won't be charged yet, please proceed to the next step.",
            "display-company-info": "Display company information",
            "billing-address-is-shipping-address": "Billing address is the same as shipping address",
            "multiple-items-in-cart": "You have multiple items in your shopping cart. You can choose between different shipping methods for each item.",
            "order-success": "Your order was completed successfuly!",
            "payment-canceled": "Payment canceled",
            "payment-canceled-message": "Thank you for using our store!",
            "wrong-payment-amount": "Payment error, please try again!",
            "step-number": "Step {number}",
            "step-of-total": "Step {number} of {total}",
            "step-invoicing-address": "Invoicing",
            "step-shipping-address": "Address",
            "step-shippingMethod": "Shipping",
            "step-paymentMethod": "Payment",
            "step-summary": "Summary",
            "store_name": "Store name",
            "return-policy": "Terms & conditions",
            "payment-method-cod": "Cash on delivery",
            "payment-method-paypal": "PayPal",
            "payment-method-wire": "Bank Transfer",
            "payment-method-stripe": "Stripe",
            "bank-instructions": "Instructions for buyers regarding Bank transfer",
            "accept": "Accept",
            "b2b": "B2B",
            "newsletter": "subscribe to newsletter",
            "payment-method-netopia": "NETOPIA Payments (Mobilpay)"
        }
    },
    "gr": {
        "register": [],
        "settings": [],
        "subscription": [],
        "cart": [],
        "subscription-product": [],
        "common": [],
        "prices": [],
        "invoice": [],
        "auth": [],
        "pages": {
            "home": [],
            "contact": []
        },
        "sku": [],
        "mail": [],
        "routes": [],
        "user": []
    },
    "it": {
        "register": [],
        "settings": [],
        "subscription": [],
        "cart": [],
        "subscription-product": [],
        "common": [],
        "prices": [],
        "invoice": [],
        "auth": [],
        "pages": {
            "home": [],
            "contact": []
        },
        "sku": [],
        "mail": [],
        "routes": [],
        "user": []
    },
    "ro": {
        "register": {
            "title": "Înregistrare cont nou",
            "firstName": "Prenume",
            "lastName": "Nume",
            "email": "E-mail",
            "password": "Parola",
            "confirmPassword": "Confirmare parolă",
            "companyName": "Nume companie",
            "companyRegistrationNumber": "Număr de înregistrare al companiei",
            "address": "Adresa",
            "city": "Localitatea",
            "postalCode": "Cod poștal",
            "country": "Țara",
            "industry": "Domeniul",
            "position": "Funcția",
            "phoneNumber": "Număr telefon",
            "manageAccount": {
                "help": "Administratorul va putea încarca fișiere video, subtitrări, imagini și țări"
            },
            "manageAccount.help": "Administratorul va putea încarca fișiere video, subtitrări, imagini și țări",
            "register-button": "Înregistrare",
            "managedAccount": "Permit administratorului să administreze contul meu. Tarifat doar în lunile cu activitate",
            "allow-admin-to-manage-account": "Administratorul va putea încărca fisiere video, imagini și alte informații",
            "acceptTerms": "Sunt de acord cu termenii și condițiile",
            "acceptNewsletter": "Sunt de acord să mă abonez la știrile VOYPP",
            "login": "Autentificare",
            "success": "Înregistrare reușită",
            "success-text": "Vă rugăm să verificati casuța de mesaje și confirmați adresa de e-mail. După confirmare, așteptați până când un administrator va aproba contul dumneavoastră. Veți fi notificat in cel mai scurt timp, apoi vă veți putea autentifica. Mulțumim!",
            "success-verified": "Vă rugăm să așteptați până când un administrator va aproba contul dumneavoastră. Veți fi notificat in cel mai scurt timp, apoi vă veți putea autentifica. Mulțumim!",
            "approved": "Aprobat de administrator",
            "county": "Județul",
            "company_data_required": "Informațiile companiei sunt necesare"
        },
        "settings": {
            "slot-subscription-price": "Prețul abonamentului per slot",
            "slot-subscription-discount": "Reducere la abonamentul pe slot",
            "slot-subscription-price-day-threshold": "Costul pe zi pentru întârzierea plății abonamentului pentru slot",
            "not-defined": "Configurarea {setting} nu a fost definită",
            "managed_user_account_subscription_product": "Abonamentul care poate fi administrat",
            "mail_new_account_registered": "E-mail - creare cont nou",
            "mail_new_manage_account_subscription": "E-mail - nou cont administrat",
            "mail_new_tags_order": "E-mail - nouă comandă pentru taguri",
            "mail_new_transaction_success": "E-mail - tranzacție reușită",
            "mail_failed_transaction": "E-mail - tranzacție eșuată",
            "max_sku_slots": "Numărul maxim de sloturi",
            "max_chars_title_subtitle": "Numărul maxim de caractere pentru titlu / subtitlu",
            "max_chars_sku_description": "Numar maxim de caractere pentru descrierea SKU",
            "mail_expiry_sku": "E-mail - Acest SKU se apropie de expirare",
            "slot-subscription-vat": "TVA abonament slot"
        },
        "order": {
            "orders": "Comenzi",
            "order": "Comandă",
            "id": "#ID",
            "date": "Data",
            "status": "Stare",
            "quantity": "Cantitate",
            "total": "Total",
            "no-items": "Nicio comandă",
            "subscriptions": "Abonamente",
            "name": "Nume",
            "created_on": "Creeat la",
            "due_date": "Până la data",
            "price-per-month": "Cost lunar",
            "view": "Vizualizare",
            "unsubscribe": "Dezabonare",
            "invoices": "Facturi",
            "no-invoices": "Nicio factură",
            "lines": "Linii",
            "download-pdf": "Descarcă PDF",
            "paid-at": "Plătit la",
            "summary": "Sumar comandă",
            "manual_pay": "Plata se efectuează manual",
            "manual_pay_pending": "Plata manuală în așteptare",
            "price": "Preț",
            "manage_plan": "Administrează",
            "envelops": "Plicuri",
            "parcels": "Colete",
            "weight_kg": "Masa (kg)",
            "length": "Lungime",
            "width": "Latime",
            "height": "Inaltime",
            "no-payments": "Nu sunt plăți",
            "payment-identifier": "Id-ul plății",
            "ref-num": "Numărul de referință al Id-ului",
            "sales": "Vânzările din magazin",
            "thanks": "Mulțumim!",
            "order_confirmation": "Comandă confirmată",
            "order_shipping_soon": "Comanda dvs. a fost confirmată și va fi livrată curând.",
            "successful_order": "Finalizați comanda",
            "finish_order": "Finalizați comanda",
            "netopia_noua": "Noua",
            "netopia_deschisa": "Deschisa",
            "netopia_platita": "Platita",
            "netopia_confirmata": "Confirmata",
            "netopia_anulata": "Anulata",
            "netopia_in_asteptare": "In asteptare",
            "netopia_in_verificare": "In verificare",
            "netopia_creditata": "Creditata",
            "wrong_amount": "Suma de bani platita nu este egala cu valoarea comenzii.",
            "paid_nedd_shipping": "Comanda a fost platita si urmeaza sa fie livrata.",
            "paid_completed": "Comanda a fost achitata si a fost finalizata cu succes.",
            "payment_processed": "Plata este in curs de procesare.",
            "payment_nedd_captured": "Plata a fost acceptata, asigurati-va ca intrati in posesia ei.",
            "payment_not_received": "Tranzactia a esuat, plata ta nu a fost receptionata.",
            "payment_refund": "Plata a fost credit. Banii sunt returnati clientului.",
            "payment_wrong_args": "Procesatorul de plati a trimisi parametri eronati.",
            "payment_invalid_action": "Procesatorul de plati a trimisi o actiune eronata.",
            "payment_will_process": "Plata dumneavoastra este in curs de procesare. In curand veti primi un e-mail de confirmare."
        },
        "passwords": {
            "password": "Parolele trebuie să aibă minim opt caractere și să coincidă.",
            "reset": "Parola dumneavoastră a fost resetată.",
            "sent": "V-am trimis linkul de schimbare a parolei, pe adresa dumneavoastră de e-mail.",
            "token": "Token-ul de schimbare a parolei este greșit.",
            "user": "Utilizatorul sau adresa de e-mail nu au fost găsite în baza noastră de date."
        },
        "profile": {
            "my-account": "Contul meu",
            "account-details": "Detalii cont",
            "change-password": "Schimbare parolă",
            "old-password": "Parola veche",
            "new-password": "Noua parolă",
            "new-password-confirm": "Confirmare parolă",
            "account-deleted": "Cont șters",
            "password-changed": "Parolă schimbată",
            "incorrect-old-password": "Parolă incorectă",
            "profile-updated": "Profil actualizat",
            "email-taken": "Adresa de e-mail este deja asociată altui cont",
            "edit-profile": "Editare profil",
            "blocked-by": "Contul blocat de utilizatorul {user} la data {date}",
            "account-status": "Situația contului",
            "block-user": "Blocare utilizator",
            "block-user-confirm": "Explicație mesaj",
            "reason": "Motiv",
            "unblock-user": "Deblocare utilizator",
            "account-role": "Rolul contului",
            "save-role": "Salvare rol",
            "maximum_slots": "Numărul maxim de sloturi admis"
        },
        "subscription": {
            "new-subscription": "Abonare nouă",
            "select": "Selectare",
            "subscribe-plan": "Abonare pentru {price} per lună",
            "subscribe": "Abonare",
            "create-invoice": "Crează factură"
        },
        "cart": {
            "go-to-cart": "Coșul meu ({items} buc.)",
            "added": "Actualizare coș",
            "sku": "SKU",
            "type": "Tip",
            "quantity": "Cantitate",
            "unit-price": "Preț unitar",
            "subtotal": "Subtotal",
            "total": "Total",
            "pcs": "buc.",
            "no-items": "Niciun articol",
            "cart": "Coș de cumpăraturi",
            "year": "Anul",
            "years": "Ani",
            "checkout": "Verificare comandă",
            "invoice-details": "Detalii factură",
            "vat-not-included": "TVA nu este inclus",
            "name": "Nume",
            "shipping-details": "Detalii transport",
            "copy-from-invoice-details": "Copie din detaliile facturii",
            "no-items-in-cart": "Coșul de cumpărături este gol.",
            "pending": "În așteptare",
            "complete": "Complet",
            "shipped": "Trimis",
            "invoice": "Factura",
            "shipping": "Transport",
            "place-order": "Plasare comandă",
            "order-placed": "Comanda plasată cu succes",
            "product": "Produs",
            "update": "Actualizare",
            "updated": "Actualizare coș",
            "payment-received": "Plata a fost Încasată",
            "redirecting-to-payment": "Redirecționează spre plată",
            "reviewcart-contents": "Vă rugăm verificați conținutul coșului",
            "review-cart": "Verificare coș",
            "not-compatible": "Acest produs nu este compatibuil cu produsele deja existente în coș din cauză că are o valută diferită sau altă metodă de plată. Vă rugăm comandați acest produs separat.",
            "refused": "Refuzat",
            "canceled": "Anulat",
            "refunded": "Rambursat",
            "to_be_shipped": "Pentru livrare",
            "product-not-for-sale": "Produsul nu este disponibil momentan"
        },
        "subscription-product": {
            "create": "Creeare",
            "name": "Nume",
            "price": "Preț",
            "vat": "TVA (%)",
            "no-content": "Niciun articol",
            "edit": "Editare",
            "delete": "Ștergere",
            "subscription-products": "Abonamente",
            "cant-delete-managed-account-subscription": "Abonamentul nu poate fi șters. Întâi trebuie să modificați setările.",
            "draft": "Schiță",
            "published": "Publicat",
            "pending_payment": "Plată în așteptare",
            "description": "Descriere",
            "months": "Luni"
        },
        "order-history": {
            "date": "Data",
            "author": "Autor",
            "content": "Conținut",
            "post": "Mesaj postare"
        },
        "common": {
            "voypp": "voypp",
            "tagline": "video on your product platform",
            "home": "Acasă",
            "terms-and-conditions": "Termeni și condiții",
            "welcome": "Bine ați venit",
            "filter": "Filtrare",
            "search": "Căutare…",
            "reset": "Reinițializare",
            "previous": "Înapoi",
            "next": "Înainte",
            "pagination-summary": "Se afișează {perPage}, dintr-un total de {total} înregistrări",
            "menu": {
                "about": "despre Voypp",
                "how-it-works": "cum funcționează",
                "prices": "prețuri",
                "join-the-platform": "alaturați-vă platformei",
                "contact": "contact",
                "login": "login",
                "register": "înregistrare",
                "dashboard": "Tablou de bord",
                "logout": "logout"
            },
            "administration": "Administrare",
            "users": "Utilizatori",
            "tags": "Taguri",
            "tag-prices": "Prețuri taguri",
            "content": "Conținut",
            "translations": "Traduceri",
            "close": "Închide",
            "save": "Salvează",
            "non-empty-html": "{attribute} nu trebuie să fie gol",
            "are-you-sure": "Sunteți sigur(ă) că doriți să continuați?",
            "save-error-title": "Eroare la salvarea datelor",
            "generic-error": "S-a produs o eroare. Vă rugăm să verificați mai jos:",
            "impersonating": "Veți avea rolul acestui utilizator.",
            "impersonating-stop": "Înapoi",
            "copyright-protected": "Protejat de copyright",
            "powered-by": "Realizat de",
            "trashed": "Șters",
            "with-trashed": "Inclusiv șterse",
            "only-trashed": "Doar șterse",
            "yes": "Da",
            "no": "Nu",
            "back": "Înapoi",
            "pcs": "buc.",
            "delete": "Ștergere",
            "all": "Toate",
            "data-saved": "Date salvate",
            "no-items": "Niciun articol",
            "parameter-must-be-a-list": "Parametrul {attribute} trebuie să fie o listă",
            "locale-not-set": "Traducerea {locale} pentru parameterul {attribute} nu este configurat!",
            "page": "Pagina",
            "widget": "Widget",
            "platform": "Platforma",
            "video": "Video pe serverul Voypp",
            "vimeo": "Video pe server extern",
            "image": "Imagine",
            "privacy-policy": "Politica de confidențialitate",
            "monthly-subscription": "Abonare lunară la {product}",
            "payment-successful": "Plată întregistrată cu succes",
            "pending-payment": "Plata in așteptare",
            "payment-error": "Eroare la efectuarea plății",
            "paid": "Plătit",
            "overdue": "Întârziere",
            "canceled": "Anulat",
            "draft": "Schiță",
            "invoices": "Facturi",
            "cancel": "Anulare",
            "settings": "Configurare",
            "ok": "OK",
            "dashboard": "Tablou de bord",
            "subscription-plans": "Abonamente",
            "subscription-plan": "abonament",
            "pay-now": "Plătesc acum",
            "order": "Comandă",
            "menu-footer": {
                "facebook": "Facebook",
                "newsletter": "newsletter",
                "e-mail": "e-mail",
                "contact": "contact",
                "gdpr": "GDPR",
                "terms-and-conditions": "termeni și condiții",
                "login": "Login"
            },
            "mail-recommendation-body": "Vă recomand această  pagină: {appURL}",
            "mail-recommendation-subject": "Recomandare",
            "mail-recommendation-title": "Recomandare prin e-mail",
            "fb-share-title": "Publică pe Facebook",
            "follow": "Urmărește",
            "top": "Sus",
            "share": "Recomandă",
            "sku-mail-recommendation-body": "Am descoperit o informație interesantă despre  {producer} {brand}: {appURL}",
            "sku-fb-recommendation-body": "Am descoperit o informație interesantă despre  {producer} {brand}: {appURL}",
            "subscription-to": "Abonamentul produsului",
            "cookie": {
                "consent_text": "Acest microsite utilizează cookie pentru a personaliza experiența dvs. și pentru a înțelege cum utilizați acest serviciu, pentru a-l îmbunătăți în viitor.",
                "uses_cookies": "Acest microsite utilizează cookie",
                "only_required": "Doar cele esențiale",
                "allow_all": "Permiteți toate",
                "view_all": "Vedeți toate cookie",
                "used": "Cookie folosite de acest microsite",
                "name": "Nume",
                "description": "Descriere",
                "no_cookie": "Fără cookie",
                "loading": "Încarcă...",
                "reject": "Refuză cookieurile"
            },
            "example": "Ex.",
            "word": "cuvânt",
            "submit": "Aplică",
            "error-terms": "Trebuie să fiți de acord cu termenii și condițiile",
            "customer-name": "Numele clientului",
            "return-policy": "Politica de retur",
            "captcha-required": "Vă rugăm verificați că nu sunteți robot",
            "captcha-error": "Eroare captcha! Incercați din nou sau contactați administratorul siteului.",
            "weechat-share-title": "Distribuiți pe Wechat",
            "whatsapp-share-title": "Distribuiți pe Whatsapp",
            "telegram-share-title": "Distribuiți pe Telegram",
            "instagram-share-title": "Distribuiți pe Instagram",
            "carousel": "Carusel",
            "no-trashed": "Exclus șters",
            "contact-list": "Lista de contacte"
        },
        "prices": {
            "prices": "Prețuri",
            "configure-title": "Configurare prețuri",
            "explain": "Se începe prin adăugarea tuturor tipurilor de tag-uri și toate tipurile variațiilor de prețuri.",
            "types": "Tipuri",
            "min-quantity": "Cantitatea minimă",
            "add-new-type": "Adăugare tip nou",
            "add-new-year": "Adăugare an",
            "add-new-min-quantity": "Adăugare cantitate minimă",
            "type": "Tip",
            "year": "An",
            "quantity": "Cantitate",
            "delete": "Ștergere",
            "no-types": "Nu a fost definit niciun tip. Adaugați unul, folosing formularul de mai sus.",
            "no-years": "Nu a fost definit niciun an. Adăugați unul, folosing formularul de mai sus.",
            "no-min-quantity": "Nu a fost definită cantitatea minimă. Adaugați, folosing formularul de mai sus.",
            "save-configuration": "Salvați configurația",
            "configuration-saved": "Configurația a fost salvată",
            "years": "Ani",
            "prices-input-not-a-list": "{attribute} nu este o lista de prețuri",
            "price-does-not-have-a-type-set": "{attribute} are prețul căruia îi lipsește un tip de variabilă",
            "price-does-not-have-a-year-set": "{attribute} are prețul căruia îi lipsește anul",
            "price-does-not-have-a-quantity-set": "{attribute} are prețul căruia îi lipsește cantitatea",
            "price-does-not-have-a-price-set": "{attribute} are prețul căruia îi lipsește variația de preț",
            "tag-prices": "Prețuri taguri"
        },
        "invoice": {
            "invoice": "Factura",
            "vat": "TVA",
            "date": "Data",
            "due_date": "Până la data",
            "product": "Produs",
            "quantity": "Cantitate",
            "rate": "Rata",
            "subtotal": "Subtotal",
            "total": "Total",
            "from": "De la",
            "to": "Până la",
            "name": "Nume",
            "company": "Compania",
            "address": "Adresa",
            "this-month-income": "Venit luna curentă",
            "income-change-thesame": "Nicio schimbare fața de luna precedentă",
            "income-change-decrease": "{change}% scădere față de luna precedentă",
            "income-change-increase": "{change}% creștere fața de luna precedentă",
            "description": "Descriere",
            "amount": "Valoare",
            "price_unit": "Preț unit.",
            "discount": "Reducere",
            "total_net": "Total net",
            "base": "Preț bază",
            "disclaimer_title": "Notes & information:",
            "disclaimer_line1": "Această factura se anulează automat în 5 zile lucrătoare, dacă în contract nu este stipulat alt termen. Prezentați această factură în cazul unor reclamații.",
            "disclaimer_line2": "Pentru mai multe informații, vizitați www.voypp.com.",
            "disclaimer_line3": "Vă mulțumim pentru alegerea VOYPP.",
            "paid_at": "Data plății:",
            "demo": "Demo",
            "income-previous-empty": "Nu au fost vânzări luna trecută",
            "this-month-sales": "Vânzările din luna curentă"
        },
        "contact": {
            "title": "Contact form"
        },
        "content": {
            "title": "Titlu",
            "created-date": "Creat la",
            "no-content": "Fără conținut",
            "create": "Creeare",
            "content": "Conținut",
            "edit": "Editare",
            "type": "Tip",
            "slug": "Combinație",
            "slug-taken": "Combinația a fost deja folosită!",
            "preview": "Previzualizare",
            "delete": "Ștergere",
            "content-deleted": "Conținut șters"
        },
        "translations": {
            "id": "ID",
            "save_error_title": "Eroare la salvarea traducerii"
        },
        "auth": {
            "failed": "Aceste credențiale sunt diferite de înregistrările noastre.",
            "resend-verification-email": "Retrimite e-mailul de verificare",
            "verification-ok": "Verificarea e-mailului este îndeplinită",
            "account_not_activated": "Contul dvs. nu este încă activat de administrator. Încercați mai târziu.",
            "verification-resent": "Un nou link de verificare a fost trimis către e-mailul dvs.",
            "resetPass": "Resetează parola",
            "confirmPassword": "Confirmă parola",
            "throttle": "Prea multe încercări de logare.Vă rugăm incercați în {seconds} secunde.",
            "login-title": "Login",
            "login-button": "Login",
            "logout-button": "Ieșire",
            "forgot-password-link": "Ai uitat parola?",
            "remember": "Reține setările",
            "register-title": "Înregistrează",
            "register-button": "Înregistrează-te aici",
            "login-text": "Deja ai un cont?",
            "register-text": "Dorești un cont?",
            "password": "Parolă",
            "email": "E-mail",
            "profile": "Profil",
            "verify-your-email-address": "Verifică adresa de e-mail",
            "reset-success": "Parola a fost schimbată cu succes"
        },
        "pages": {
            "home": {
                "title": "Produse cu taguri NFC/coduri QR VOYPP®",
                "subtitle": "Folosește-ți creativitatea pentru a comunica cu clienții, direct prin produsul tău, oriunde acesta este disponibil.",
                "about": {
                    "title": "Despre VOYPP®",
                    "content": "VOYPP® este prima platformă automatizată NFC/QR DTC/CTP (Direct-To-Consumer / Communicate Through Product) ce oferă informații selectate despre un produs, la raft sau orinde produsul este accesibil cumpărătorului. <br/> Scanează tagul NFC/codul QR și vizualizează pagina produsului, cu până la 10 sloturi de informație. Găsește instant promoțiile active sau alte date relevante."
                },
                "how-it-works": {
                    "title": "Cum funcționează",
                    "content": "Ești cumpărător și ai găsit un produs/serviciu cu tag NFC sau cod QR Voypp? Activează funcția NFC a mobilului tău și atinge cu mobilul tagul NFC lipit pe produs, sau scanează codul QR. Accesează pagina dedicată și alege slotul cu informația pe care dorești să o vezi. Video-uri scurte și la obiect sau alte materiale îți vor arata elemente importante despre subiectul ales. Descoperă promoții disponibile în zona ta. Față în față cu produsul, creatori experimentați de conținut îți vor dezvălui diverse aspecte pentru a evalua mai ușor acel produs/serviciu."
                },
                "prices": {
                    "title": "Prețuri taguri",
                    "content": "Pornind de la 0,15 euro, până la 5.04 euro/tag NFC, variind în funcție de cantitate. Separat poți comanda taguri cu diverse forme sau grafică, taguri speciale pentru suport metalic sau taguri combinate NFC sau RFID. În același timp, ai libertatea de a produce tagurile NFC sau etichetele cu coduri QR oriunde dorești, în acest caz poți utiliza platforma plătind doar sloturile active, 5 euro/slot/lună. Putem gestiona contul tău, indiferent de numărul de SKU-uri, pentru 25 euro/lună. TVA nu este inclus."
                },
                "join": {
                    "title": "Alătură-te platformei noastre!",
                    "content": "Ești producător și dorești să utilizezi platforma? Înregistrează-te și crează SKU-urile dorite. Alege cantitatea necesară de taguri NFC, crează și încărcă conținutul pe platformă. Asta e tot ca ai de făcut. De restul ne ocupăm noi. Tagurile tale vor putea fi folosite oriunde în lume (inclusiv în China). Scanează codul QR de mai jos cu mobilul tău și vezi cum arată și cum funcționează o pagină de produs.",
                    "button": "Înregistrare"
                },
                "join.button": "Înregistrare",
                "tagline": "video on your product platform"
            },
            "contact": {
                "title": "Formular de contact",
                "full_name": "Numele și prenumele",
                "full_name_placeholder": "Introdu numele tău",
                "email": "E-mail",
                "email_placeholder": "Introdu adresa ta de e-mail",
                "message": "Mesaj",
                "message_placeholder": "Completează mesajul",
                "submit": "Trimite mesajul",
                "phone_placeholder": "Introdu numărul tău de telefon",
                "city_placeholder": "Localitatea",
                "phone": "Telefon",
                "city": "Localitatea",
                "mandatory_fields": "Câmp obligatoriu"
            }
        },
        "sku": {
            "sku-list": "Lista SKU",
            "order-new-sku": "Comandă un SKU",
            "prices": "Prețuri",
            "code": "Cod",
            "description": "Descriere",
            "tags-ordered": "Tag-uri comandate",
            "created-date": "Data creării",
            "no-skus": "Nu a fost definit niciun SKU",
            "order": "Comandă",
            "sku": "SKU",
            "edit": "Editare",
            "order-labels": "Comandă etichete",
            "analytics": "Statistici",
            "new-sku": "Adăugare",
            "edit-sku-information": "Editare informații SKU",
            "save": "Salvare rol",
            "code-explain": "3 charactere + 2 cifre",
            "slot": "Slot",
            "add-slot": "Adăugare slot",
            "remove-slot": "Ștergere slot",
            "video": "Video",
            "image": "Imagine",
            "producer": "Producător",
            "brand": "Brand",
            "video-file": "Fișier video",
            "video-file-help": "Încărcați fișiere video de max. 400Mb",
            "image-file": "Fișier tip imagine",
            "image-file-help": "(Fișiere .jpg, .png, .gif)",
            "media-type": "Tip conținut",
            "preview": "Previzualizare",
            "action": "Acțiune",
            "url": "URL",
            "saving-title": "Salvare SKU",
            "delete": "Ștergere",
            "title": "Titlu",
            "title-help": "maxim 25 charactere titlu + subtitlu",
            "subtitle": "Subtitlu",
            "characters-remaining": "Caractere rămase:",
            "uploading": "Se încarca, vă rugam nu închideți fereastra până când transferul nu se finalizează",
            "video-will-be-loaded-soon": "În curând, aici va fi încărcat un fișier video. Vă rugam să reîncercați putin mai târziu.",
            "live-url": "URL public",
            "no-live-url-yet": "URL-ul va fi vizibil, dacă veți comanda cel putin un tag.",
            "views-count": "Număr de vizualizări",
            "current-image": "Imaginea curentă",
            "delete-image": "Ștergere imagine",
            "draft": "Schiță",
            "published": "Publicat",
            "tags": "Tag-uri",
            "tags-orderd-pcs": "Număr de tag-uri comandate",
            "order-date": "Data comenzii",
            "delivery_date": "Data livrării",
            "status": "Situație",
            "uid-loaded": "UID încărcat",
            "unit-price": "Preț unitar",
            "total": "Total",
            "active-blocked": "Activ(e) / blocat(e)",
            "pending": "În așteptare",
            "in_production": "În producție",
            "delivered": "Livrat",
            "blocked": "Blocat",
            "active": "activ",
            "pcs": "buc.",
            "order-tag": "Comandă tag",
            "create-sku": "Creaza SKU",
            "edit-sku": "Editează SKU",
            "no-tags": "Niciun tag nu a fost comandat",
            "order-tags": "Comandă tag-uri",
            "delete-video": "Ștergere video",
            "video-proccesing": "Se procesează fisierul video",
            "please-check-later": "Vă rugam să verificați mai târziu pentru a vedea cât a progresat",
            "note": "Notă",
            "tags-are-active-at-delivery": "La livrare, tag-urile sunt active",
            "year": "An",
            "years": "Ani",
            "nfc-tags": "Tag-uri NFC",
            "quantity": "Cantitatea",
            "add-to-cart": "Adaugă în coș",
            "tag-type": "Tipul tag-ului",
            "vat-not-included": "TVA nu este inclus",
            "cart": "În coșul de cumpărături",
            "invalid-cart-item": "Articolul din coș nu este valid",
            "price-per-unit": "Preț unitar",
            "qty": "cant.",
            "paid": "Plătit",
            "sent": "Trimis",
            "delivery": "livrare",
            "state": "Stare",
            "sent-to-production": "Trimis in producție",
            "uuid-loaded": "UID încărcate",
            "view": "Vizualizare",
            "general": "General",
            "slots": "Sloturi",
            "statistics": "Statistici",
            "publish": "Link-ul codului QR",
            "publish-slot": "Publicare slot pentru {price} pe lună",
            "date": "Data",
            "client": "Client",
            "location": "Locația",
            "no-views": "Nicio vizualizare",
            "color": "Culoarea de fundal",
            "text_color": "Culoarea textului",
            "white": "Alb",
            "black": "Negru",
            "no-info": "Nicio informație disponibilă",
            "full-asset": "Complet",
            "file": "Fișier",
            "view-file": "Vizualizare fișier",
            "delete-file": "Ștergere fișier",
            "unpublish": "Oprește publicarea",
            "slot-pending-payment": "Plata pentru publicarea slotului este în așteptare",
            "slot-name": "SKU {sku} slot #{order}",
            "complete-the-payment": "Plătiți {price} pe lună",
            "cancel": "Anulare",
            "pending_payment": "Plată în așteptare",
            "sku-views": "Vizualizări SKU",
            "sku-count-change-thesame": "Neschimbat față de luna precedentă",
            "registered-skus": "SKU înregistrate",
            "see-all": "Vedeți toate",
            "sku-count-change-decrease": "{change}% scădere față de luna precedentă",
            "sku-count-change-increase": "{change}% crestere față de luna precedentă",
            "total-views": "Total vizualizări",
            "views": "{count} vizualizări",
            "active-slots": "{active} / {count} sloturi",
            "download-image": "Descarcă imagea",
            "download-pdf": "Descarcă PDF",
            "clone": "Clonează",
            "action-text": "Text",
            "assign_to_user": "Assignați SKU altui utilizator",
            "export-by-date": "Raport pe zile",
            "export-by-country": "Raport pe țară",
            "publish_all_slots": "Publicare SKU",
            "slots_published_success": "SKU a fost publicat cu succes",
            "slots_published_error": "Eroare la publicarea SKU",
            "address": "Adresă",
            "email": "E-mail",
            "tel": "Telefon",
            "landing_page": "Landing page",
            "txt": "Text",
            "ga_code": "Google Analytics",
            "slots-count": "Numărul de sloturi",
            "remove_vertical_space": "Spațiu vertical între sloturi = 0",
            "facebook": "Facebook",
            "contact_email": "E-mail-ul formularului de contact",
            "contact_intro_text": "Textul introductiv al formularului de contact",
            "contact_visible": "Arată formularul de  contact",
            "contact_failed": "Formularul de contact nu poate fi procesat. Vă rugăm completați câmpurile obligatorii!",
            "disable_header": "Ascunde headerul",
            "keywords": "Cuvinte cheie",
            "retargeting_scripts": "Scriptul Retargeting",
            "no-action": "Nicio acțiune",
            "alt_text": "Alt text",
            "redirect": "SKU ascuns (redirecționare către URL-ul extern)",
            "redirect_url": "Redirecționare către URL",
            "map": "Harta",
            "views_chart": "Graficul vizualizărilor",
            "unique": "Vizualizări unice",
            "daily-views": "Vizualizări zilnice",
            "top-visitors": "Topul vizitatorilor",
            "visits": "Vizite",
            "visitors": "Vizitatori",
            "views-map": "Harta vizualizărilor SKU-ului",
            "show_ip": "Afișează IP-ul",
            "hide_ip": "Ascunde IP-ul",
            "unique_views": "{count} vizualizări unice",
            "sku_views": "Vizualizări SKU",
            "slot_views": "Vizualizări sloturi",
            "download-eps": "Salvează eps",
            "export-by-slot": "Export pe sloturi",
            "export": "Export",
            "landing_page_header": "Header-ul Landing page-ului",
            "contact_landing_success": "Formularul a fost înregistrat cu succes. Vă rugăm să verificați adresa dvs. de e-mail, unde veți primi un link ce vă va permite să accesați pagina solicitată.",
            "ip": "IP",
            "country": "Țară",
            "total-views_num": "{count} total vizualizări",
            "buy_button_background_color": "Buton Cumpără - culoare de fundal",
            "auto_play": "Auto play",
            "shop": "Magazin",
            "autoplaySpeed": "Viteza de derulare carusel",
            "max_slots": "Utilizatorul a depășit numărul maxim de sloturi!",
            "save_domains": "Salvați",
            "is_domain_active": "Activați domeniul",
            "domain_name": "Numele domeniului",
            "domains": "Domeniu",
            "weechat-share-text": "Scanați \"QR Code\" în Wechat și click {icon} pentru a recomanda!",
            "disable_email_share": "Dezactivați recomandarea prin email",
            "disable_facebook_share": "Dezactivați recomandarea prin Facebook",
            "disable_weechat_share": "Dezactivați recomandarea prin Wechat",
            "disable_telegram_share": "Dezactivați recomandarea prin Telegram",
            "disable_instagram_share": "Dezactivați recomandarea prin Instagram",
            "disable_whatsapp_share": "Dezactivați recomandarea prin Whatsapp",
            "width": "Lățime",
            "allow_pan": "Permiteți glisarea",
            "instagram": "Instagram",
            "weechat": "Wechat",
            "messenger": "Messenger",
            "telegram": "Telegram",
            "whatsapp": "Whatsapp",
            "category": {
                "removed": "Folderul a fost șters cu succes!",
                "delete": "Stergeți folderul",
                "add": "Adăugați un folder",
                "name": "Numele folderului"
            },
            "customer_mail_intro_text": "Textul de introducere a emailului către vizitator",
            "add-field": "Adăugați un câmp nou",
            "contact_form_type_custom": "Formular customizat",
            "contact_form_type_contact": "Formular contact",
            "disable_captcha": "Dezactivați captcha",
            "contact_form_type": "Tipul formularului",
            "contact_title": "Titlul formularului",
            "buy_button_text_color": "Butonul Cumpără - culoarea textului",
            "contact_form_fields": "Câmpuri formular personalizat",
            "no_horizontal_space": "Eliminare spatiere orizontala"
        },
        "pagination": {
            "previous": "&laquo; Înapoi",
            "next": "Înainte &raquo;"
        },
        "mail": {
            "contact": {
                "success": "Mesajul a fost trimis cu succes!"
            },
            "subjects": {
                "new-user": "Nou utilizator înregistrat",
                "new-user-to-manage": "Cont nou de administrat",
                "approved-user": "Voypp - Activare cont",
                "order-created": "Comandă nouă",
                "expiry_user_notify": "Voypp - Subscription renewal",
                "expiry_admin_notify": "Voypp Subscription to renew",
                "sku-contact": "Mesaj nou SKU - {SKU}",
                "verify-email": "Confirmarea adresei de e-mail",
                "sku-landing-token": "Confirmă adresa de e-mail",
                "bank_transfer_info": "Transfer bancar - informații",
                "succesful_payment_buyer_notify": "Plată nouă",
                "succesful_payment_admin_notify": "Voypp = plata nouă",
                "sku-custom-form-customer": "Confirmare pentru informații SKU {SKU}",
                "sku-custom-form": "Informații pentru formular nou - SKU {SKU}"
            },
            "messages": {
                "registered": "Un nou utilizator cu adresa de e-mail {email} s-a înregistrat pe platforma dumneavoastră.",
                "user_to_manage": "A new user with e-mail {email} a solicitat sa ii administrati contul.",
                "approved-user": "Contul dumneavoastră a fost activat de administrator. Acum puteți sa vă autentificati pe platforma noastră.",
                "order-created": "A fost trimisă o comandă nouă.",
                "expiry_user_notify": "Publicarea SKU-ul dvs. {SKU_code} va expira la data de {due_date}. Dacă doriți continuarea publicării, vă rugăm efectuați plata pentru perioada dorită, altfel SKU-ul va fi oprit de la publicare automat. Vă mulțumim!",
                "expiry_admin_notify": "Publicarea SKU-ul dvs. {SKU_code} va expira la data de {due_date}. Dacă doriți continuarea publicării, vă rugăm efectuați plata pentru perioada dorită, altfel SKU-ul va fi oprit de la publicare automat. Vă mulțumim!",
                "sku-contact-line1": "{name} ți-a trimis un mesaj",
                "verify-email-line1": "Vă rugăm să dați click pe butonul de mai jos pentru verificarea adresei de e-mail",
                "verify-email-line2": "Administratorul va verifica contul tău, apoi vei primi un e-mail de confirmare, după care va fi posibil să te autentifici.",
                "verify-email-line3": "Dacă dumneavoastră nu ați creat un cont, puteți ignora acest mesaj.",
                "verify-email-button": "Confirmarea adresei de e-mail",
                "sku-landing-token-line1": "Vezi mai multe detalii despre {SKU}",
                "sku-landing-token-button": "OK",
                "follow-order-link": "Puteți urmări comanda la acest link:",
                "hello": "Bună ziua, {name}",
                "payment-value-buyer": "O plată de {value}{currency} a fost înregistrată cu succes pentru comanda #{orderId}!",
                "download-invoice-link": "Puteți descărca factura la acest link:",
                "payment-value-admin": "O plată de {value}{currency} a fost înregistrată pentru această comandă #{orderId}!",
                "thank-you-for-buying": "Vă mulțumim pentru cumpărături din magazinul {storeName}!",
                "thank-you-order": "Vă mulțumim pentru comandă!",
                "succesful_payment_buyer_notify": "Plata pentru comanda #{orderId} a fost înregistrată!",
                "succesful_payment_admin_notify": "Plata pentru comanda #{orderId} a fost înregistrată!",
                "sku-custom-form-customer-line1": "Ați introdus următoarele informații",
                "sku-custom-form-line1": "Ați primit noi informații pentru \"{formTitle}\""
            }
        },
        "routes": {
            "car": "oferta",
            "terms-and-conditions": "Termeni și condiții",
            "privacy-policy": "Politica de confidențialitate",
            "raffle": "Tombola",
            "success": "succes",
            "offer-form": "Formular ofertă",
            "contact-form": "Formular-contact",
            "allow-cookie": "permite cookie-uri",
            "car-category": "categorie"
        },
        "user": {
            "name": "Nume",
            "email": "E-mail",
            "created-date": "Data creării",
            "tags-ordered": "Tag-uri comandate",
            "edit": "Editare",
            "new-user": "Utilizator nou",
            "no-users": "Nici un utilizator",
            "impersionate": "Administrează",
            "delete": "Ștergere",
            "user-created": "Utilizator creat",
            "roles": "Roluri",
            "blocked-by": "Contul dumneavoastra a fost blocat de {user} la {date}. Motivul: {reason}.",
            "blocked": "Blocat",
            "clients": "Clienți",
            "administrators": "Administratori",
            "user-blocked": "Utilizatorul a fost blocat",
            "profile": "Profil",
            "orders": "Comenzi",
            "subscriptions": "Abonamente",
            "registered-users": "Utilizatori înregistrați",
            "count-users": "{count} utilizatori",
            "count-change-thesame": "Niciun utilizator nou față de luna precedentă",
            "count-change-decrease": "{change}% scădere față de luna precedentă",
            "count-change-increase": "{change}% creștere față de luna precedentă",
            "SKU-count": "număr SKU",
            "confirmedSince": "Confirmat din {date}",
            "confirmAccount": "Confirmați Contul"
        },
        "validation": {
            "accepted": "Câmpul {attribute} trebuie să fie acceptat.",
            "active_url": "Câmpul {attribute} nu este un URL valid.",
            "after": "Câmpul {attribute} trebuie să fie o dată după {date}.",
            "after_or_equal": "Câmpul {attribute} trebuie să fie o dată ulterioară sau egală cu {date}.",
            "alpha": "Câmpul {attribute} poate conține doar litere.",
            "alpha_dash": "Câmpul {attribute} poate conține doar litere, numere și cratime.",
            "alpha_num": "Câmpul {attribute} poate conține doar litere și numere.",
            "array": "Câmpul {attribute} trebuie să fie un array.",
            "before": "Câmpul {attribute} trebuie să fie o dată înainte de {date}.",
            "before_or_equal": "Câmpul {attribute} trebuie să fie o dată înainte sau egală cu {date}.",
            "between": {
                "numeric": "Câmpul {attribute} trebuie să fie între {min} și {max}.",
                "file": "Câmpul {attribute} trebuie să fie între {min} și {max} kiloocteți.",
                "string": "Câmpul {attribute} trebuie să fie între {min} și {max} caractere.",
                "array": "Câmpul {attribute} trebuie să aibă între {min} și {max} elemente."
            },
            "boolean": "Câmpul {attribute} trebuie să fie adevărat sau fals.",
            "confirmed": "Confirmarea {attribute} nu se potrivește.",
            "date": "Câmpul {attribute} nu este o dată validă.",
            "date_equals": "Aceasta {attribute} trebuie să fie o dată egală cu {date}.",
            "date_format": "Câmpul {attribute} trebuie să fie în formatul {format}.",
            "different": "Câmpurile {attribute} și {other} trebuie să fie diferite.",
            "digits": "Câmpul {attribute} trebuie să aibă {digits} cifre.",
            "digits_between": "Câmpul {attribute} trebuie să aibă între {min} și {max} cifre.",
            "dimensions": "Câmpul {attribute} are dimensiuni de imagine nevalide.",
            "distinct": "Câmpul {attribute} are o valoare duplicat.",
            "email": "Câmpul {attribute} trebuie să fie o adresă de e-mail validă.",
            "ends_with": "Câmpul {attribute} trebuie să se încheie cu una din următoarele valori: {values}",
            "exists": "Câmpul {attribute} selectat nu este valid.",
            "file": "Câmpul {attribute} trebuie să fie un fișier.",
            "filled": "Câmpul {attribute} trebuie completat.",
            "gt": {
                "numeric": "Câmpul {attribute} trebuie să fie mai mare de {value}.",
                "file": "Câmpul {attribute} trebuie să fie mai mare de {value} kilobyți.",
                "string": "Câmpul {attribute} trebuie să fie mai mare de {value} caractere.",
                "array": "Câmpul {attribute} trebuie să aibă mai multe de {value} elemente."
            },
            "gte": {
                "numeric": "Câmpul {attribute} trebuie să fie mai mare sau egal cu {value}.",
                "file": "Câmpul {attribute} trebuie să fie mai mare sau egal cu {value} kilobyți.",
                "string": "Câmpul {attribute} trebuie să fie mai mare sau egal cu {value} caractere.",
                "array": "Câmpul {attribute} trebuie să aibă {value} elemente sau mai multe."
            },
            "image": "Câmpul {attribute} trebuie să fie o imagine.",
            "in": "Câmpul {attribute} selectat nu este valid.",
            "in_array": "Câmpul {attribute} nu există în {other}.",
            "integer": "Câmpul {attribute} trebuie să fie un număr întreg.",
            "ip": "Câmpul {attribute} trebuie să fie o adresă IP validă.",
            "ipv4": "Câmpul {attribute} trebuie să fie o adresă IPv4 validă.",
            "ipv6": "Câmpul {attribute} trebuie să fie o adresă IPv6 validă.",
            "json": "Câmpul {attribute} trebuie să fie un string JSON valid.",
            "lt": {
                "numeric": "Câmpul {attribute} trebuie să fie mai mic de {value}.",
                "file": "Câmpul {attribute} trebuie să fie mai mic de {value} kilobyți.",
                "string": "Câmpul {attribute} trebuie să fie mai mic de {value} caractere.",
                "array": "Câmpul {attribute} trebuie să aibă mai puțin de {value} elemente."
            },
            "lte": {
                "numeric": "Câmpul {attribute} trebuie să fie mai mic sau egal cu {value}.",
                "file": "Câmpul {attribute} trebuie să fie mai mic sau egal cu {value} kilobyți.",
                "string": "Câmpul {attribute} trebuie să fie mai mic sau egal cu {value} caractere.",
                "array": "Câmpul {attribute} trebuie să aibă {value} elemente sau mai puține."
            },
            "max": {
                "numeric": "Câmpul {attribute} nu poate fi mai mare de {max}.",
                "file": "Câmpul {attribute} nu poate avea mai mult de {max} kiloocteți.",
                "string": "Câmpul {attribute} nu poate avea mai mult de {max} caractere.",
                "array": "Câmpul {attribute} nu poate avea mai mult de {max} elemente."
            },
            "mimes": "Câmpul {attribute} trebuie să fie un fișier de tipul: {values}.",
            "mimetypes": "Câmpul {attribute} trebuie să fie un fișier de tipul: {values}.",
            "min": {
                "numeric": "Câmpul {attribute} nu poate fi mai mic de {min}.",
                "file": "Câmpul {attribute} trebuie să aibă cel puțin {min} kiloocteți.",
                "string": "Câmpul {attribute} trebuie să aibă cel puțin {min} caractere.",
                "array": "Câmpul {attribute} trebuie să aibă cel puțin {min} elemente."
            },
            "not_in": "Câmpul {attribute} selectat nu este valid.",
            "not_regex": "Câmpul {attribute} nu are un format valid.",
            "numeric": "Câmpul {attribute} trebuie să fie un număr.",
            "password": "Parola este greșită.",
            "present": "Câmpul {attribute} trebuie să fie prezent.",
            "regex": "Câmpul {attribute} nu are un format valid.",
            "required": "Câmpul {attribute} este obligatoriu.",
            "required_if": "Câmpul {attribute} este necesar când {other} este {value}.",
            "required_unless": "Câmpul {attribute} este necesar, cu excepția cazului {other} este in {values}.",
            "required_with": "Câmpul {attribute} este necesar când există {values}.",
            "required_with_all": "Câmpul {attribute} este necesar când există {values}.",
            "required_without": "Câmpul {attribute} este necesar când nu există {values}.",
            "required_without_all": "Câmpul {attribute} este necesar când niciunul(una) dintre {values} nu există.",
            "same": "Câmpul {attribute} și {other} trebuie să fie identice.",
            "size": {
                "numeric": "Câmpul {attribute} trebuie să fie {size}.",
                "file": "Câmpul {attribute} trebuie să aibă {size} kiloocteți.",
                "string": "Câmpul {attribute} trebuie să aibă {size} caractere.",
                "array": "Câmpul {attribute} trebuie să aibă {size} elemente."
            },
            "starts_with": "Acesta {attribute} trebuie să înceapă cu una din următoarele: {values}",
            "string": "Câmpul {attribute} trebuie să fie string.",
            "timezone": "Câmpul {attribute} trebuie să fie un fus orar valid.",
            "unique": "Câmpul {attribute} a fost deja folosit.",
            "uploaded": "Câmpul {attribute} nu a reușit încărcarea.",
            "url": "Câmpul {attribute} nu este un URL valid.",
            "uuid": "Acesta {attribute} trebuie să fie un cod UID valid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "mesaj personalizat"
                }
            },
            "attributes": []
        },
        "shop": {
            "bank-instructions": "Instrucțiuni pentru plata prin transfer bancar",
            "payment-method-stripe": "Stripe",
            "payment-method-paypal": "PayPal",
            "payment-method-cod": "Plata ramburs la livrare",
            "payment-method-wire": "Transfer bancar",
            "return-policy": "Termeni și condiții",
            "store_name": "Numele magazinului online",
            "step-summary": "Sumar",
            "step-paymentMethod": "Plata",
            "step-shippingMethod": "Livrare",
            "step-shipping-address": "Adresa",
            "step-invoicing-address": "Facturare",
            "step-of-total": "Pas {number} {total}",
            "step-number": "Pas {number}",
            "wrong-payment-amount": "Eroare de plată, mai încercați o dată!",
            "payment-canceled-message": "Vă mulțumim pentru cumpărăturile din magazinul nostru!",
            "payment-canceled": "Plată anulată",
            "order-success": "Comanda dvs. a fost înregistrată cu succes!",
            "multiple-items-in-cart": "Puteți avea mai multe produse în coș. Puteți alege mai multe metode de livrare pentru fiecare produs.",
            "billing-address-is-shipping-address": "Adresa de facturare este aceeași cu adresa de livrare",
            "display-company-info": "Vizualizați informațiile companiei",
            "not-charget-yet": "Pentru plată, vă rugăm continuați cu următorul pas.",
            "shipping-cost": "Costul livrării",
            "shipping-updates": "Actualizarea livrării",
            "shipping-address": "Adresa de livrare",
            "invoicing-info": "Informații privind factura",
            "invoicing-address": "Adresa de facturare",
            "remove-item-error": "Produsul nu poate fi șters din coș",
            "remove": "Anulați",
            "items-in-cart": "Produsele din coșul dvs.",
            "ship-tax-info": "Costul livrării va fi calculat la final.",
            "shopping-cart-empty": "Coșul dvs. este gol!",
            "shopping-cart": "Coș de cumpărături",
            "buy-now": "Cumpărați acum",
            "choose-payment-method": "Alegeți metoda de plată",
            "choose-shipping-method": "Alegeți metoda de livrare",
            "shippingMethod": "Metoda de livrare",
            "shippingMethods": "Modurile de livrare",
            "paymentMethod": "Modul de plată",
            "paymentMethods": "Metodele de plată",
            "currency": "Valuta",
            "in_stoc": "Pe stoc",
            "enabled": "Activat",
            "disabled": "Dezactivat",
            "out_of_stoc": "Produsul nu este pe stoc",
            "accept": "Accept",
            "b2b": "B2B",
            "newsletter": "Abonare la newsletter"
        }
    },
    "ru": {
        "register": [],
        "settings": [],
        "subscription": [],
        "cart": [],
        "subscription-product": [],
        "common": [],
        "prices": [],
        "invoice": [],
        "auth": {
            "failed": "",
            "throttle": "",
            "login-title": "",
            "login-button": ""
        },
        "pages": {
            "home": {
                "prices": {
                    "content": "1"
                }
            },
            "contact": []
        },
        "sku": [],
        "mail": [],
        "routes": [],
        "user": []
    }
}
